import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  InputAdornment,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Paper,
  MenuItem,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  ThemeProvider,
  Container ,
  CardContent,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useStyles } from "../../theme/appStyles";
import {
  useDeleteCustomerProjectMutation,
  useDeleteCustomerTransactionMutation,
  useGetCustomerProjectQuery,
  useGetCustomerQuery,
  useGetCustomerTransactionQuery,
  useGetWorkOrderByCustomerProjectQuery,
  useRemovedCustomerProjectMMutation,
  useGetAllInvoiceQuery,
  useGetWorkOrderQuery,
  useCreateEmailMutation, 
  useCreateTextMutation, 
  useCreateNoteMutation,
  useCreateNoteEmailMutation,
  useGetEmailTemplateQuery,
  useGetNoteTemplateQuery,
  useGetActivityHistoryQuery,
  useGetAllWorkOrderHistoryCustomerQuery,
  useDeleteCustomerMutation,
  useGetContractInvoicesQuery,
  useGetSmsTemplatesQuery,
} from "../../Api/attoDeskApi";
import {
  ICustomer,
  ICustomerProject,
  ICustomerTransaction,
  IEmailTemplate,
  INoteTemplate,
  IInvoice,
  IContractInvoice,
  IQuoteWorkOrder,
  IActivityHistoryApiResponse,
  ICompanyDetails,
  ISmsTemplate,
} from "../../Api/Interface/api.interface";
import NewCustomerTransactionPopUp from "./Components/NewCustomerTransactionPopUp";
      import { useNotifier } from "../../Core/Notifier";
import DeletePopup from "../../Components/Delete/DeletePopup";
import DeletePopupMutaion from "../../Components/Delete/DeletePopupMutaion";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../Components/SearchDebonce/useDebounce";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopUpCustomer from "../Customer/Edit/index";
import AddProject from "./Components/AddProject";
import ViewWorkOrder from "./Components/ViewWorkOrder";
import dayjs,  { Dayjs } from "dayjs";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AssignWorkOrder from "./Components/AssignWorkOrder";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import EmailIcon from "@mui/icons-material/Email";
import AssignmentIcon from "@mui/icons-material/Assignment";
import InfoIcon from "@mui/icons-material/Info";
import CodeIcon from "@mui/icons-material/Code";
import HistoryIcon from "@mui/icons-material/History";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import NoteIcon from "@mui/icons-material/Note";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useFormik } from "formik";
import ChatIcon from "@mui/icons-material/Chat";
import DescriptionIcon from "@mui/icons-material/Description";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import {
  WorkOrderStatus,
} from "../../Core/Enum/enum";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import CustomCheckbox from "../../Components/Checkbox.tsx";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import axios from "axios";

import html2pdf from "html2pdf.js";
import ReactPDF, { pdf } from '@react-pdf/renderer';
import ReactDOMServer from 'react-dom/server';
import { MemoryRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import store from "../../Store";
import { CssBaseline } from "@mui/material";
import { ThemeProviderWrapper } from "../../Drawer/Menu/ThemeContext";
import { NotifierProvider } from "../../Core/Notifier";
import ReactDOM from 'react-dom/client'; 
import { PDFDocument } from 'pdf-lib';
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import moment from 'moment';
import { logDOM } from "@testing-library/react";
import { Pie } from 'react-chartjs-2';
import PersonIcon from "@mui/icons-material/Person";

const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
   case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};
 

const Index = () => {
 
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [searchQueryProject, setSearchQueryProject] = useState("");
  const [currentSearchQueryProject, setCurrentSearchQueryProject] =
    useState("");
  const debouncedSearchQueryProject = useDebounce(searchQueryProject, 300);

  const [searchQueryInvoice, setSearchQueryInvoice] = useState("");
  const [searchQueryQuotes, setSearchQueryQuotes] = useState("");
  const [currentSearchQueryInvoice, setCurrentSearchQueryInvoice] =
    useState("");
  const debouncedSearchQueryInvoice = useDebounce(searchQueryInvoice, 300);
  const [currentSearchQueryQuote, setCurrentSearchQueryQuote] =
  useState("");
const debouncedSearchQueryQuote = useDebounce(searchQueryQuotes, 300);

  const [searchQueryEmailTemplate, setSearchQueryEmailTemplate] = useState("");
  const [currentSearchQueryEmailTemplate, setCurrentSearchQueryEmailTemplate] =
    useState("");
  const debouncedSearchQueryEmailTemplate = useDebounce(searchQueryEmailTemplate, 300);
  const [searchQueryNoteTemplate, setSearchQueryNoteTemplate] = useState("");
  const [currentSearchQueryNoteTemplate, setCurrentSearchQueryNoteTemplate] =
    useState("");
  const debouncedSearchQueryNoteTemplate = useDebounce(searchQueryNoteTemplate, 300);
  const { id: customerId } = useParams<{ id: string }>();
  const [selectCustomer, setSelectCustomer] = useState<ICustomer | null>(null);
  const [transactionData, setTransactionData] =
    useState<ICustomerTransaction>();

  // const [deleteCategory] = useDeleteCustomerTransactionMutation();
    const [deleteCategory] = useDeleteCustomerMutation();
  const [deleteProject] = useDeleteCustomerProjectMutation();

  const [openDialog, setOpenDialog] = useState(false);
  const [openAddTransaction, setOpenAddTransaction] = useState(false);
  const [openAddProject, setOpenAddProject] = useState(false);
  const [openViewInvoice, setOpenViewInvoice] = useState(false);
  const [openViewQuote, setOpenViewQuote] = useState(false);
  const [projectData, setProjecData] = useState<ICustomerProject>();

  const [openAddWorkOrder, setOpenAddWorkOrder] = useState(false);
  const [WorkOrderData, setWorkOrderData] = useState<IQuoteWorkOrder>();

  const { showErrorMessage, showMessage } = useNotifier();
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<ICustomer | null>(null);

  const [openDeleteProject, setOpenDeleteProject] = useState(false);
  const [projectToDelete, setProjectToDelete] =
    useState<ICustomerProject | null>(null);

  const [openDeleteProjectWrokOrder, setOpenDeleteProjectWrokOrder] =
    useState(false);
  const [projectWrokOrderToDelete, setProjectWrokOrderToDelete] =
    useState<IQuoteWorkOrder | null>(null);

  const [openProjectTable, setOpenProjectTable] = useState(false);
  const [projectId, setProjectId] = useState<number>(0);
  const [projectName, setProjectName] = useState<string>("");
  const [expandedSteps, setExpandedSteps] = useState<number[]>([]);

  const [newNote, { isLoading: isNoteSaving }] = useCreateNoteMutation();
  const [newNoteEmail, { isLoading: isNoteEmailSaving }] = useCreateNoteEmailMutation();
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {}, [customerId]);

  const [showProject, setShowProject] = useState(false);
  const [showQuotes, setShowQuotes] = useState(true);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showContractInvoice, setShowContractInvoice] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [showTextForm, setShowTextForm] = useState(false);
  const [showNoteForm, setShowNoteForm] = useState(false);
  const [showProfileForm, setShowProfileForm] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [newEmail, { isLoading: isEmailSending }] = useCreateEmailMutation();
  const [newText, { isLoading: isTextSending }] = useCreateTextMutation();
  const [isSendAsEmail, setIsSendAsEmail] = useState(false);
  const ReactQuillRef = useRef(null);
  const [invoiceId, setInvoiceId] = useState("");
  const [quoteId, setQuoteId] = useState("");
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [selectedRowsQuotes, setSelectedRowsQuotes] = useState<number[]>([]);
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [invoiceEmailData, setInvoiceEmailData] = useState({ to: "", template:"", subject: "", message: "" , attachments: [] });
  const invoiceRef = useRef<HTMLDivElement | null>(null);
  const [generatedAttachments, setGeneratedAttachments] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [emailLog, setEmailLog] = useState<EmailLogs[]>([]); 
  const [noteLog, setNoteLog] = useState<NoteLogs[]>([]); 
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const PAYMENT_URL = process.env.REACT_APP_PAYMENT_URL;

  interface InvoiceEmailData {
    customer_id: number;
    to: string;
    template: string;
    subject: string;
    message: string;
    attachments: File[]; // Ensure attachments is an array of File objects
  }

  interface EmailLogs {
    id: number;
    created_at: string;
    subject: string;
    message?: string;
    to?: string;
  }



  interface NoteLogs {
    id: number;
    created_at: string;
    subject: string;
    message?: string;
  }

  interface TransactionType {
    id: number;
    InvoiceNo: string;
   quoteWorkOrderCompanyId: number;
     quoteWorkOrderCustomerId: string;
     quoteWorkOrderNo: string;
     quoteWorkOrderIssueDate: string | null;
     quoteWorkOrderDueDate: string | null; 
     quoteWorkOrderAmount: number | null;
     quoteWorkOrderStatus: number;
    //  quoteWorkOrderSale: ProductSale[];
     quoteWorkOrderDiscount: string;
     quoteWorkOrderSubTotal: string;
     quoteWorkOrderSaleGrandTotal: string;
     quoteWorkOrderSaleDiscountDescription: string | null;
     customer: ICustomer;
     company: ICompanyDetails;
     created_at: string;
  }

  interface IProduct {
    productName: string;
    productDescription: string;
    productImg: String | null;
    numberOfPassengers: number | null;
    transferType: string;
    transferTypeFrom: string;
    transferTypeTo: string;
    transferTypeDescription: string;
    departureDateTime: Dayjs | null;
    returnDateTime: Dayjs | null;
    departureAddress: string;
    destinationAddress: string;
    multiDestination: string;
    quantity: number | null;
    price: number | null;
    tax: number | null;
    taxAmount: number | null;
    total: number;
    taxId: number | null;
    unitPriceWithDiscount: number | null;
    unitTotalWithDiscount: number;
    productType: string;
    productLongDescription: string;
    productShortDescription: string;
  }

  interface IDiscount {
    value: number | null;
    description: string;
  }

  const { data, isLoading, isError } = useGetCustomerQuery({
    searchText: "",
    id: String(customerId),     
  });


  const formatAddressReadOnly = (
    streetNumber: string,
    streetName: string,
    postalCode: string,
    city: string,
    province: string
  ) => {
    return `${streetNumber} ${streetName}, ${city}, ${province}, ${postalCode}`;
  };
  const customerFormatAddressReadOnly = (
    streetNumber: string,
    streetName: string,
    postalCode: string,
    city: string,
    province: string
  ) => {
    return `${streetNumber} ${streetName}, ${city}, ${province}, ${postalCode}`;
  };

  const initialCompanyAddress = formatAddressReadOnly(
    WorkOrderData?.company.companyStreetNumber || "",
    WorkOrderData?.company.companyStreetName || "",
    WorkOrderData?.company.companyPostalCode || "",
    WorkOrderData?.company.companyCity || "",
    WorkOrderData?.company.companyProvince || ""
  );

  const initialCustomerAddress = customerFormatAddressReadOnly(
    WorkOrderData?.customer.customerStreetNumber || "",
    WorkOrderData?.customer.customerStreetName || "",
    WorkOrderData?.customer.customerPostalCode || "",
    WorkOrderData?.customer.customerCity || "",
    WorkOrderData?.customer.customerProvince || ""
  );
  
  const {
    data: customerTransactionData,
    isLoading: customerDataIsLoading,
    refetch,
  } = useGetCustomerTransactionQuery({
    searchText: currentSearchQuery,
    customerId: String(customerId),
    projectId: "",
  });

  const {
    data: activityHistoryData,
    isLoading: activityHistoryIsLoading,
    refetch: refetchActivityHistory,
  } = useGetActivityHistoryQuery({
    searchText: "",
    id: String(customerId),  
  });

  

  const {
    data: customerProjectData,
    isLoading: customerProjectDataIsLoading,
    refetch: cutomerProjectRefetch,
  } = useGetCustomerProjectQuery({
    searchText: currentSearchQueryProject,
    customerId: String(customerId),
    id: "",
  });

  const {
    data: workOrderProjectData,
    isLoading: workOrderProjectDataIsLoading,
    refetch: workOrderProjectRefetch,
  } = useGetWorkOrderByCustomerProjectQuery({
    searchText: "",
    quoteWorkOrderCustomerId: String(customerId),
    quoteWorkOrderCustomerProjectId: String(projectId),
  });

  
    const {
      data: quoteData,
      isLoading: quoteIsLoading,
      isError: quoteError,
      refetch: quoteRefetch,
    } = useGetWorkOrderQuery({
      searchText: currentSearchQueryQuote,
      id: "",
      quoteWorkOrderCustomerId: String(customerId),
    });
  

  const {
    data: invoiceData,
    isLoading: invoiceIsLoading,
    isError: invoiceError,
    refetch: invoiceRefetch,
  } = useGetAllInvoiceQuery({
    searchText: currentSearchQueryInvoice,
    id: "",
    quoteWorkOrderCustomerId: String(customerId),
    quoteWorkOrderCustomerProjectId: "",
  });

  const { data : allInvoiceData, isLoading : allInvoiceIsLoading } = useGetAllInvoiceQuery({
    searchText: currentSearchQuery,
    id: "",
    quoteWorkOrderCustomerId: "",
    quoteWorkOrderCustomerProjectId: "",
  });

  const {
    data: contractInvoiceData,
    isLoading: contractInvoiceIsLoading,
    refetch: contractInvoiceRefetch,
  } = useGetContractInvoicesQuery({
    customer_id: customerId ? String(customerId) : null,
  });

  const {
    data: emailTemplateData,
    isLoading: emailTemplateIsLoading,
    isError: emailTemplateError,
    refetch: emailTemplateRefetch,
  } = useGetEmailTemplateQuery({
    searchText: currentSearchQueryEmailTemplate,
    // id: "",
  });

  

  const {
    data: noteTemplateData,
    isLoading: noteTemplateIsLoading,
    isError: noteTemplateError,
    refetch: noteTemplateRefetch,
  } = useGetNoteTemplateQuery({
    searchText: currentSearchQueryNoteTemplate,
    // id: "",
  });

  const {
    data: smsTemplateData,
  } = useGetSmsTemplatesQuery({});

   const {
      data: workOrderData,
      isLoading: workIsLoading,
      isError: workOrderError,
      refetch: workOrderRefetch,
    } = useGetWorkOrderQuery({
      searchText: "",
       id: "",
      // id: String(quoteId),
    });

const {
    data: workOrderHistoryData,
    isLoading: workOrderHistoryIsLoading,
    isError: workOrderHistoryError,
    refetch: workOrderHistoryRefetch,
  } = useGetAllWorkOrderHistoryCustomerQuery({
    //id:"",
     id: String(customerId),
  });

    const WorkOrderDataList = useMemo(() => {
      if (
        workOrderData &&
        Array.isArray(workOrderData.data) &&
        workOrderData.data.length > 0
      ) {
        return workOrderData.data[0] as IQuoteWorkOrder;
      }
      return null;
    }, [workOrderData]);

    


    const timeLineSteps1 = React.useMemo(() => {
      if (
        workOrderHistoryData &&
        Array.isArray(workOrderHistoryData.data) &&
        workOrderHistoryData.data.length > 0
      ) {
        return workOrderHistoryData.data.map((order, index) => {
          const label =
            index === 0
              ? "Quote created"
              : order.isInvoice
              ? "Quote converted to invoice"
              : "Quote edited";
  
          const description = (
            <div>
              {index === 0 && (
                <div>
                    <Typography variant="body1">
                    <strong>Quote Number :</strong> {order.quoteWorkOrderNo}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Created by :</strong> {order.updated_by}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Created at :</strong>{" "}
                    {order?.created_at
                      ? dayjs(order.created_at).format("MMM D, YYYY [at] h:mm A")
                      : ""}
                  </Typography>
                </div>
              )}
  
              {order.isInvoice == true && (
                <div>
                  <Typography variant="body1">
                    <strong>Invoice Number :</strong> {order.InvoiceNo}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Converted by :</strong> {order.updated_by}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Converted at :</strong>{" "}
                    {order?.created_at
                      ? dayjs(order.created_at).format("MMM D, YYYY [at] h:mm A")
                      : ""}
                  </Typography>
                  <Grid item textAlign={"end"} justifyContent={"flex-end"}>
                    <Button
                      variant="contained"
                      startIcon={<VisibilitySharpIcon />}
                      className={classes.addButton}
                      onClick={() =>
                        navigate(
                          `/invoice/history/${WorkOrderDataList?.invoiceId}`
                        )
                      }
                    >
                      Invoice
                    </Button>
                  </Grid>
                </div>
              )}
              {order.isInvoice == false && index != 0 && (
                <div>
                    <Typography variant="body1">
                    <strong>Quote Number :</strong> {order.quoteWorkOrderNo}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Edited by :</strong> {order.updated_by}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Edited at :</strong>{" "}
                    {order?.updated_at
                      ? dayjs(order.updated_at).format("MMM D, YYYY [at] h:mm A")
                      : ""}
                  </Typography>
                </div>
              )}
              <Typography variant="body1"> </Typography>
              <TableContainer sx={{ marginTop: 2 }}>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      <TableCell className={classes.tablheader}>
                        <strong>Product</strong>
                      </TableCell>
                      {/* <TableCell
                        className={classes.tablheader}
                        sx={{ textAlign: "right" }}
                      >
                        <strong>Quantity</strong>
                      </TableCell> */}
                      <TableCell
                        className={classes.tablheader}
                        sx={{ textAlign: "right" }}
                      >
                        <strong>Price</strong>
                      </TableCell>
                      {/* <TableCell
                        className={classes.tablheader}
                        sx={{ textAlign: "right" }}
                      >
                        <strong>Tax</strong>
                      </TableCell> */}
                      {/* <TableCell
                        className={classes.tablheader}
                        sx={{ textAlign: "right" }}
                      >
                        <strong>Price After Discount</strong>
                      </TableCell> */}
                      {/* <TableCell
                        className={classes.tablheader}
                        sx={{ textAlign: "right" }}
                      >
                        <strong>Total</strong>
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {workOrderError || order.quoteWorkOrderSale.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          {workOrderError
                            ? "Error fetching data"
                            // : "No data available"
                            :""
                            }
                        </TableCell>
                      </TableRow>
                    ) : (
                      order.quoteWorkOrderSale.map(
                        (
                          row: IProduct,
                          index: number 
                        ) => (
                          <TableRow key={index} className={classes.tableRowHover}>
                            <TableCell scope="row" className={classes.tablCell}>
                              {row.productName}
                            </TableCell>
                            {/* <TableCell className={classes.tablCell} align="right">
                              {row.quantity}
                            </TableCell> */}
                            <TableCell className={classes.tablCell} align="right">
                              {row.price !== null && row.price !== undefined
                                ? row.price.toFixed(2)
                                : "0.00"}
                            </TableCell>
                            {/* <TableCell className={classes.tablCell} align="right">
                            
                              {row.taxAmount}
                            </TableCell> */}
                            {/* <TableCell className={classes.tablCell} align="right">
                              {(row.unitPriceWithDiscount ?? 0).toFixed(2)}
                            </TableCell> */}
                            {/* <TableCell className={classes.tablCell} align="right">
                              {row.unitTotalWithDiscount != null
                                ? row.unitTotalWithDiscount.toFixed(2)
                                : "0.00"}
                            </TableCell> */}
                          </TableRow>
                        )
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid container>
                {workOrderError ||
                order.quoteWorkOrderSaleDiscountDescription.length === 0 ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {workOrderError ? "Error fetching data" 
      
                      // : "No data available"
                            :""
                    }
                  </Grid>
                ) : (
                  order.quoteWorkOrderSaleDiscountDescription.map(
                    (discount: IDiscount, index: number) => (
                      <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
                        <Grid
                          container
                          spacing={2}
                          display={"end"}
                          justifyContent={"flex-end"}
                        >
                          <Grid
                            item
                            lg={2}
                            md={2}
                            sm={4}
                            xs={8}
                            textAlign={"end"}
                          >
                            <Typography>
                              {discount.description || "Discount"}
                              {" :"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={2}
                            md={2}
                            sm={2}
                            xs={4}
                            textAlign={"end"}
                          >
                            <Typography>
                              {"$"}
                              {(discount.value ?? 0).toFixed(2)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  )
                )}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    spacing={2}
                    display={"end"}
                    justifyContent={"flex-end"}
                  >
                    <Grid
                      item
                      lg={2}
                      md={2}
                      sm={4}
                      xs={8}
                      textAlign={"end"}
                      className={classes.tablCell}
                    >
                      <Typography>Total Discount :</Typography>
                    </Grid>
                    <Grid
                      item
                      lg={2}
                      md={2}
                      sm={2}
                      xs={4}
                      textAlign={"end"}
                      className={classes.tablCell}
                    >
                      <Typography>
                        {"$"}
                        {Number(order.quoteWorkOrderDiscount || 0).toFixed(2)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    spacing={2}
                    display={"end"}
                    justifyContent={"flex-end"}
                  >
                    <Grid item lg={2} md={2} sm={4} xs={8} textAlign={"end"}>
                      <Typography style={{fontWeight:'bold'}}>
                        Grand Total :
                      </Typography>
                    </Grid>
                    <Grid item lg={2} md={2} sm={2} xs={4} textAlign={"end"}>
                      <Typography style={{fontWeight:'bold'}} >
                        {"$"}
                        {Number(order.quoteWorkOrderSaleGrandTotal || 0).toFixed(
                          2
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          );
  
          return {
            label: label,
            description: description,
          };
        });
      }
      return [];
    }, [workOrderHistoryData]);


  const [newCustomer, { isLoading: rmoveIsLoading }] =
    useRemovedCustomerProjectMMutation();

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ICustomer;
    }
    return null;
  }, [data]);


  const activityHistory = useMemo(() => {
    if (data && data.data) {
      return data as IActivityHistoryApiResponse; // Cast the entire response to the expected type
    }
    return null;
  }, [data]);
  

  const transactions: ICustomerTransaction[] = useMemo(() => {
    if (
      customerTransactionData &&
      Array.isArray(customerTransactionData.data)
    ) {
      return customerTransactionData.data as ICustomerTransaction[];
    }
    return [];
  }, [customerTransactionData]);

  const project: ICustomerProject[] = useMemo(() => {
    if (customerProjectData && Array.isArray(customerProjectData.data)) {
      return customerProjectData.data as ICustomerProject[];
    }
    return [];
  }, [customerProjectData]);

  const workOrderProject: IQuoteWorkOrder[] = useMemo(() => {
    if (workOrderProjectData && Array.isArray(workOrderProjectData.data)) {
      return workOrderProjectData.data as IQuoteWorkOrder[];
    }
    return [];
  }, [workOrderProjectData]);

  const invoiceList: IInvoice[] = useMemo(() => {
    if (invoiceData && Array.isArray(invoiceData.data)) {
      return invoiceData.data as IInvoice[];
    }
    return [];
  }, [invoiceData]);

  const coursings: IInvoice[] = Array.isArray(allInvoiceData?.data) ? (allInvoiceData?.data as IInvoice[]) : [];

  const quoteList: IQuoteWorkOrder[] = useMemo(() => {
    if (quoteData && Array.isArray(quoteData.data)) {
      return quoteData.data as IQuoteWorkOrder[];
    }
    return [];
  }, [quoteData]);

  // Work orders that have been converted to invoices for this customer
  const invoicedWorkOrders: IQuoteWorkOrder[] = useMemo(() => {
    return quoteList.filter((t) => t.invoiceId);
  }, [quoteList]);


    // const quoteList: IQuoteWorkOrder[] = Array.isArray(data?.data)
    //   ? (data?.data as IQuoteWorkOrder[])
    //   : [];
  

  const emailTemplateList: IEmailTemplate[] = useMemo(() => {
    if (emailTemplateData && Array.isArray(emailTemplateData.data)) {
      return (emailTemplateData.data as IEmailTemplate[]).filter(
        (t) => !t.is_mandatory
      );
    }
    return [];
  }, [emailTemplateData]);

  const noteTemplateList: INoteTemplate[] = useMemo(() => {
    if (noteTemplateData && Array.isArray(noteTemplateData.data)) {
      return noteTemplateData.data as INoteTemplate[];
    }
    return [];
  }, [noteTemplateData]);

  const smsTemplateList: ISmsTemplate[] = useMemo(() => {
    if (smsTemplateData && Array.isArray(smsTemplateData.data)) {
      return (smsTemplateData.data as ISmsTemplate[]).filter((t) => !t.is_system && t.is_active);
    }
    return [];
  }, [smsTemplateData]);

 // Use invoicedWorkOrders as primary data source for stats; fall back to invoiceList
 const effectiveSource: Array<{ quoteWorkOrderSaleGrandTotal: string; amount_paid?: number | string | null; created_at: string }> =
   invoiceList.length > 0 ? invoiceList : invoicedWorkOrders;

 const totalSales = effectiveSource.length;

 const totalAmount = effectiveSource.reduce((sum, inv) => {
  const amount = parseFloat(inv.quoteWorkOrderSaleGrandTotal || "0");
  return sum + (isNaN(amount) ? 0 : amount);
}, 0);

const totalDueAmount = effectiveSource.reduce((sum, inv) => {
  const grandTotal = parseFloat(inv.quoteWorkOrderSaleGrandTotal || "0");
  const amtPaid = parseFloat(String(inv.amount_paid ?? "0"));
  const due = Math.max(0, grandTotal - amtPaid);
  return sum + (isNaN(due) ? 0 : due);
}, 0);


 const lastSaleDate = effectiveSource
    .map((inv) => inv.created_at)
    .filter(Boolean)
    .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())[0];

const overallAmount = coursings.reduce((sum, invoice) => sum + Number(invoice.quoteWorkOrderSaleGrandTotal || 0), 0);

  //  const handleSelectRow = (id: number) => {
  //   setSelectedRows((prevSelected) =>
  //     prevSelected.includes(id)
  //       ? prevSelected.filter((rowId) => rowId !== id)
  //       : [...prevSelected, id]
  //   );

  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    const handleSelectRow = async (id: number) => {
      // Update the selectedRows state by either adding or removing the row ID
      setSelectedRows((prevSelected) => {
        const updatedSelectedRows = prevSelected.includes(id)
          ? prevSelected.filter((rowId) => rowId !== id)
          : [...prevSelected, id];
    
     
        // if (!prevSelected.includes(id)) {
        //   handleGeneratePDF1(id); // Only generate PDF if the row is being selected
        // }
    
        return updatedSelectedRows;
      });
    };

    const handleSelectRowQuotes = async (id: number) => {
      // Update the selectedRows state by either adding or removing the row ID
      setSelectedRowsQuotes((prevSelected) => {
        const updatedSelectedRows = prevSelected.includes(id)
          ? prevSelected.filter((rowId) => rowId !== id)
          : [...prevSelected, id];
    
        
        // if (!prevSelected.includes(id)) {
        //   handleGeneratePDFQuote(id); // Only generate PDF if the row is being selected
        // }
    
        return updatedSelectedRows;
      });
    };
  const handleSelectAllRows = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
        const ids = invoicedWorkOrders.length > 0
          ? invoicedWorkOrders.map((t) => t.id)
          : invoiceList.map((t) => t.id);
        setSelectedRows(ids);
    } else {
        setSelectedRows([]);
    }
};

const handleSelectAllRowsQuotes = (event: React.ChangeEvent<HTMLInputElement>) => {
  if (event.target.checked) {
      setSelectedRowsQuotes(quoteList.map((transaction) => transaction.id));
  } else {
      setSelectedRowsQuotes([]);
  }
};

const handleEmailDialogOpen = async () => {
 
  setPdfLoading(true);
  setInvoiceEmailData(prevState => ({
    to: prevState.to, // Keep the 'to' value unchanged
    template: '',
    subject: '',
    message: '',
    attachments: [],
  }));

  try {
    const pdfAttachments: (File | null | undefined)[] = [];

    for (const selectedRowId of selectedRows) {
      const transaction = invoiceList.find((inv) => inv.id === selectedRowId);
    
      if (!transaction) {
        console.warn(`Invoice not found for ID: ${selectedRowId}`);
        continue;
      }

      const pdfBlob = await handleGeneratePDF2(transaction.id);


      if (!pdfBlob) {
        console.warn(`Failed to generate PDF for Invoice ID: ${selectedRowId}`);
        continue;
      }

      // Ensure pdfBlob is not undefined and is a valid Blob
      if (pdfBlob instanceof Blob) {
        const file = new File([pdfBlob], `Invoice-${transaction.InvoiceNo}.pdf`, {
          type: "application/pdf",
        });
        pdfAttachments.push(file);
      } else {
        console.warn(`Invalid Blob generated for Invoice ID: ${selectedRowId}`);
      }
    }

    // Save generated attachments to state
    setGeneratedAttachments(
      pdfAttachments.filter((attachment): attachment is File => Boolean(attachment))
    );
   // console.log("Generated Attachments:", pdfAttachments);
    // Open the email dialog
    setPdfLoading(false);
    setShowEmailDialog(true);
}catch (error) {
    console.error("Error opening email dialog:", error);
    setPdfLoading(false);
  }
};

const handleQuoteEmailDialogOpen = async () => {
 
  setPdfLoading(true);
  setInvoiceEmailData(prevState => ({
    to: prevState.to, // Keep the 'to' value unchanged
    template: '',
    subject: '',
    message: '',
    attachments: [],
  }));

  try {
    const pdfAttachments: (File | null | undefined)[] = [];

    for (const selectedRowId of selectedRowsQuotes) {
      const transaction = quoteList.find((inv) => inv.id === selectedRowId);
    
      if (!transaction) {
        console.warn(`Quote not found for ID: ${selectedRowId}`);
        continue;
      }
       setQuoteId(String(transaction.id))

       
      
      const pdfBlob = await handleGeneratePDFQuote(transaction.id);
   

      if (!pdfBlob) {
        console.warn(`Failed to generate PDF for Word order ID: ${selectedRowId}`);
        continue;
      }

      // Ensure pdfBlob is not undefined and is a valid Blob
      if (pdfBlob instanceof Blob) {
        const file = new File([pdfBlob], `WorkOrder-${transaction.quoteWorkOrderNo}.pdf`, {
          type: "application/pdf",
        });
        pdfAttachments.push(file);
      } else {
        console.warn(`Invalid Blob generated for Quote ID: ${selectedRowId}`);
      }
    }

    // Save generated attachments to state
    setGeneratedAttachments(
      pdfAttachments.filter((attachment): attachment is File => Boolean(attachment))
    );
   // console.log("Generated Attachments:", pdfAttachments);
    // Open the email dialog
    setPdfLoading(false);
    setShowEmailDialog(true);
}catch (error) {
    console.error("Error opening email dialog:", error);
    setPdfLoading(false);
  }
};


// const handleGeneratePDF2 = async (invoiceId: any): Promise<Blob | null> => {
//   try {
//     setInvoiceId(invoiceId);
//     await new Promise((resolve) => setTimeout(resolve, 2000));

//     const invoice = invoiceList.find((inv) => inv.id === invoiceId);
//     if (!invoice) {
//       throw new Error(`Invoice not found for ID: ${invoiceId}`);
//     }

//     const invoiceContent = document.getElementById("invoice-content");
//     if (!invoiceContent) {
//       console.error(`Invoice content not found for Invoice ID: ${invoiceId}`);
//       return null;
//     }

//     // Show the content if hidden
//     invoiceContent.style.display = 'block';

//     // Render the content to canvas
//     const canvas = await html2canvas(invoiceContent, {
//       scale: 2,         // Keep high quality
//       useCORS: true,    // Handle external images
//       scrollY: -window.scrollY, // Prevent scroll issues
//     });

//     const imgData = canvas.toDataURL("image/jpeg", 1.0);

//     // Create jsPDF
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();

//     // Calculate scaled height to fit single page
//     const imgProps = {
//       width: pdfWidth,
//       height: (canvas.height * pdfWidth) / canvas.width
//     };

//     // If image is taller than page, scale down to fit
//     if (imgProps.height > pdfHeight) {
//       imgProps.height = pdfHeight;
//       imgProps.width = (canvas.width * pdfHeight) / canvas.height;
//     }

//     pdf.addImage(imgData, 'JPEG', 0, 0, imgProps.width, imgProps.height);

//     // Generate Blob
//     const pdfBlob = pdf.output('blob');

//     // Trigger download
//     // const pdfUrl = URL.createObjectURL(pdfBlob);
//     // const link = document.createElement('a');
//     // link.href = pdfUrl;
//     // link.download = `Invoice_${invoiceId}.pdf`;
//     // document.body.appendChild(link);
//     // link.click();
//     // document.body.removeChild(link);
//     // URL.revokeObjectURL(pdfUrl);

//     // // Hide the content again
//      invoiceContent.style.display = 'none';

//     return pdfBlob;
//   } catch (error) {
//     console.error(`Failed to generate PDF for Invoice ID: ${invoiceId}`, error);
//     return null;
//   }
// };

const handleGeneratePDF2 = async (invoiceId: any): Promise<Blob | null> => {
    try {

      setInvoiceId(invoiceId);
      await new Promise((resolve) => setTimeout(resolve, 2000));

      const invoice = invoiceList.find((inv) => inv.id === invoiceId);
      if (!invoice) {
        throw new Error(`Invoice not found for ID: ${invoiceId}`);
      }

    
      const invoiceContent = document.getElementById("invoice-content");
      if(invoiceContent)
      {
        invoiceContent.style.display = 'block';
      }

      if (!invoiceContent) {
        console.error(`Invoice content not found for Invoice ID: ${invoiceId}`);
      }


      const options = {
         margin: 0,
        filename: `Invoice_${invoiceId}.pdf`,
        image: { type: 'jpeg', quality: 0.8 }, // You can experiment with different qualities (0.8 for reduced size)
        html2canvas: {
          scale: 2, // Reduce scale for a lower resolution to make the PDF smaller
          useCORS: true, // Ensure that cross-origin images are handled properly
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };
  // Generate PDF Blob
  const pdfBlob = await html2pdf().from(invoiceContent).set(options).outputPdf('blob');



  // const pdfUrl = URL.createObjectURL(pdfBlob);

  
  // const link = document.createElement('a');
  // link.href = pdfUrl;
  // link.download = `Invoice_${invoiceId}.pdf`;
  // document.body.appendChild(link);


  // link.click();


  // document.body.removeChild(link);
  // URL.revokeObjectURL(pdfUrl);
  if(invoiceContent)
    {
  invoiceContent.style.display = 'none';
    }
  return pdfBlob;

    } catch (error) {
      console.error(`Failed to generate PDF for Invoice ID: ${invoiceId}`, error);
      return null;
//reject(error);
    }
  // });
};


// const handleGeneratePDFQuote = async (quoteId: any): Promise<Blob | null> => {
//   try {
//     setQuoteId(quoteId);
//     await new Promise((resolve) => setTimeout(resolve, 2000));

//     const quote = quoteList.find((inv) => inv.id === quoteId);
//     if (!quote) {
//       throw new Error(`Work order not found for ID: ${quoteId}`);
//     }

//     const quoteContent = document.getElementById("quote-content");
//     if (!quoteContent) {
//       console.error(`Work order content not found for work order ID: ${quoteId}`);
//       return null;
//     }

//     // Show the content if hidden
//     quoteContent.style.display = 'block';

//     // Render the content to canvas
//     const canvas = await html2canvas(quoteContent, {
//       scale: 2,
//       useCORS: true,
//       scrollY: -window.scrollY,
     
//     });

//     const imgData = canvas.toDataURL("image/jpeg", 1.0);

//     // Create jsPDF
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();

//  const imgProps = {
//       width: pdfWidth,
//       height: (canvas.height * pdfWidth) / canvas.width
//     };

//     // If image is taller than page, scale down to fit
//     if (imgProps.height > pdfHeight) {
//       imgProps.height = pdfHeight;
//       imgProps.width = (canvas.width * pdfHeight) / canvas.height;
//     }

//     pdf.addImage(imgData, 'JPEG', 0, 0, imgProps.width, imgProps.height);

//     // Generate Blob
//     const pdfBlob = pdf.output('blob');


    

//     // Trigger download
//     const pdfUrl = URL.createObjectURL(pdfBlob);
//     const link = document.createElement('a');
//     link.href = pdfUrl;
//     link.download = `Invoice_${quoteId}.pdf`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     URL.revokeObjectURL(pdfUrl);

    

//     // Hide the content again
//     quoteContent.style.display = 'none';

//     return pdfBlob;
//   } catch (error) {
//     console.error(`Failed to generate PDF for Work order ID: ${quoteId}`, error);
//     return null;
//   }
// };


const handleGeneratePDFQuote = async (quoteId: any): Promise<Blob | null> => {
  try {

    setQuoteId(quoteId);
    await new Promise((resolve) => setTimeout(resolve, 2000));

    const quote = quoteList.find((inv) => inv.id === quoteId);

   
    if (!quote) {
      throw new Error(`Work order not found for ID: ${quoteId}`);
    }

    const quoteContent = document.getElementById("quote-content");


    if(quoteContent)
    {
     
      quoteContent.style.display = 'block';
    }

    if (!quoteContent) {
      console.error(`Work order content not found for work order ID: ${quoteId}`);
    }

 
    const options = {
       margin: 1,
      filename: `WorkOrder_${quote.quoteWorkOrderNo}.pdf`,
      image: { type: 'jpeg', quality: 0.8 }, // You can experiment with different qualities (0.8 for reduced size)
      html2canvas: {
        scale: 2, // Reduce scale for a lower resolution to make the PDF smaller
        useCORS: true, // Ensure that cross-origin images are handled properly
        logging: true, // Optional: Log for debugging
      //  width: quoteContent && quoteContent.scrollWidth,
       // height: quoteContent && quoteContent.scrollHeight,
        //x: 0, // Optional: X position to start rendering
       // y: 0, // Optional: Y position to start rendering
      },
      // jsPDF: { unit: 'pt', format: 'letter', orientation: 'portrait' },
       jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    

// Generate PDF Blob
const pdfBlob = await html2pdf().from(quoteContent).set(options).outputPdf('blob');


  
          // const url = URL.createObjectURL(pdfBlob);
          // const link = document.createElement('a');
          // link.href = url;
          // link.download = `${quote.quoteWorkOrderNo}.pdf`;
          // link.click();
          // URL.revokeObjectURL(url);

if(quoteContent)
  {
    quoteContent.style.display = 'none';
  }
return pdfBlob;
  } catch (error) {
    console.error(`Failed to generate PDF for Work order ID: ${quoteId}`, error);
    return null;

  }

};


  const handleEmailDialogClose = () => setShowEmailDialog(false);

  const handleQuoteEmailDialogClose = () => setShowEmailDialog(false);

  const handleSendEmail = async () => {
    setLoading(true);

    try {
        if (!generatedAttachments.length) {
            showErrorMessage("No PDFs generated to attach. Please try again.");
            return;
        }

        const customerFirstName = customer?.customerFirstName || "Customer";
        let paymentLinks = [];
   if(selectedRows)
   {
    for (const selectedRowId of selectedRows) {
      const selectedPaymentLink = invoiceList.find((inv) => inv.id === selectedRowId);
      if (selectedPaymentLink) {
          const paymentLink = selectedPaymentLink?.payment_id
              ? `${PAYMENT_URL}/${selectedPaymentLink.payment_id}`
              : "No payment link available.";
          
          // Accumulate the payment links for each row
          paymentLinks.push(paymentLink);
      }
  }
   }
       
      const paymentLinksText = paymentLinks.join("\n");
      
          // Replace placeholders in the email message
          const updatedMessage = invoiceEmailData.message
              .replace(/\[customer_name\]/g, customerFirstName)
              .replace(/\[payment_link\]/g, paymentLinksText);

        const emailData = {
            customer_id: customerId ? parseInt(customerId, 10) : 0,
            to: invoiceEmailData.to,
            subject: invoiceEmailData.subject,
            //message: invoiceEmailData.message,
            message: convertPlainTextToHTML(updatedMessage),
            attachments: generatedAttachments,
        };

        // Create FormData object
        const formData = new FormData();
        formData.append("customer_id", emailData.customer_id.toString());
        formData.append("to", emailData.to);
        formData.append("subject", emailData.subject);
        formData.append("message", emailData.message);

        emailData.attachments.forEach((file) => {
            formData.append("attachments[]", file);
        });

        const headers = {
            Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        };

        const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

        if (emailResponse) {
            setSelectedRows([]);
            setSelectedRowsQuotes([]);
            showMessage("Email sent successfully");
            await refetchActivityHistory();
            setInvoiceEmailData({ ...invoiceEmailData, subject: "", message: "" });
            //  setGeneratedAttachments([]);
        } else {
            showErrorMessage("Failed to send email");
        }
    } catch (error) {
        console.error("Error during email sending:", error);
        showErrorMessage("Failed to send email");
    } finally {
        handleEmailDialogClose();
        setLoading(false);
    }
};

  
  const calculatePieData = (categoryName: string) => {
  //const totalExpense = categoryData[categoryName] || 0;
    const totalExpense = totalAmount || 0;
  const overallExpensePercentage = ((totalExpense / overallAmount) * 100).toFixed(2);

  return {
    labels: [`Invoice %`, `Overall %`],
    datasets: [
      {
        data: [totalExpense, overallAmount], // Data for percentage and total expense
        backgroundColor: ['#4CAF50', '#FF9800'], // Green for percentage, Orange for overall expense
        hoverOffset: 4,
      },
    ],
  };
};

  


  const stripHtmlTags = (html: string) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };


  

      const emailFormik = useFormik({
        initialValues: {
          to: "",
          subject: "",
          message: "",
          template: "",
        },
        validate: (values) => {
          const errors: { [key: string]: string } = {};
          if (!values.to) {
            errors.to = "Email address is required";
          } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.to)) {
            errors.to = "Invalid email address";
          }
         
          return errors;
        },
        onSubmit: async (values, { setValues  }) => {
          try {
            // Prepare the data to send via the newEmail API
            const emailData = {
              customer_id: customerId,
              to: values.to,
              subject: values.subject,
              message: values.message,
            };
      
            // Call the newEmail mutation API and wait for the response
            const emailResponse = await newEmail(emailData).unwrap();
            if (!emailResponse) {
              showErrorMessage("Failed to send email");
             // showErrorMessage(emailResponse.message);
            } else {
              showMessage("Email Sent successfully");
              const refetchResult = await refetchActivityHistory();
              setValues({
                ...values, // Preserve the "to" field
                subject: "", // Reset subject
                message: "", // Reset message
                template: "", // Reset template
              });
            }

          } catch (error) {
            showErrorMessage("Failed to send email");
          }
        },
      });

     


      const textFormik = useFormik({
        initialValues: {
          phone_no: "",
          message: "",
        },

        onSubmit: async (values, { setValues  }) => {
          try {
            // Prepare the data to send via the newEmail API
            const textData = {
              customer_id: customerId,
              phone_no: values.phone_no,
              message: values.message,
            };

            // Call the newEmail mutation API and wait for the response
            const textResponse = await newText(textData).unwrap();
            if (!textResponse) {
              showErrorMessage("Failed to send sms");
             // showErrorMessage(emailResponse.message);
            } else {
              showMessage("Sms Sent successfully");
              const refetchResult = await refetchActivityHistory();
              setValues({
                phone_no: values.phone_no,
                message: "",
              });
            }

          } catch (error) {
            showErrorMessage("Failed to send SMS");
          }
        },
      });

      const textFormValid = useMemo(() => {
        return textFormik.values.message.trim() !== "" && textFormik.values.phone_no.trim() !== "";
      }, [textFormik.values.message, textFormik.values.phone_no]);

      const emailFormValid = useMemo(() => {
        return (
          emailFormik.values.to !== "" &&
          emailFormik.values.to !== undefined &&
          emailFormik.values.subject !== "" &&
          emailFormik.values.subject !== undefined &&
          stripHtmlTags(emailFormik.values.message) !=="" &&
          stripHtmlTags(emailFormik.values.message) !==undefined 
        );
      }, [emailFormik.values.to, emailFormik.values.subject, emailFormik.values.message]);

      const handleNoteEmailSubmit = async (values: any, resetForm: () => void) => {
        try {
        
          const noteEmailData = {
            customer_id: customerId,
            to: customer?.customerEmail || "", // Assuming customer is available
            note_subject: values.subject,
            note_message: values.message,
          };
      
          // Call the send email API
          const emailResponse = await newNoteEmail(noteEmailData).unwrap();
          showMessage("Email Sent successfully");
          const refetchResult = await refetchActivityHistory();
          resetForm();
          setIsSendAsEmail(false);
        } catch (error) {
          showErrorMessage("Failed to send email");
        }
      };
      
      // Function to handle saving a note
      const handleNoteSaveSubmit = async (values: any, resetForm: () => void) => {
        try {
          
          const noteData = {
            customer_id: customerId,
            note_subject: values.subject,
            note_message: stripHtmlTags(values.message),
          };
      
          // Call the save note API
          const noteResponse = await newNote(noteData).unwrap();
          showMessage("Note saved successfully");
          const refetchResult = await refetchActivityHistory();
          resetForm(); // Reset the form on success
        } catch (error) {
          showErrorMessage("Failed to save note");
        } 
      };

      const noteFormik = useFormik({
        initialValues: {
          subject: "",
          message: "",
        },
     
        onSubmit: async (values, { resetForm }) => {
          if (isSendAsEmail) {
            // Submit as email
            await handleNoteEmailSubmit(values, resetForm);
          } else {
            // Save as note
            await handleNoteSaveSubmit(values, resetForm);
          }
        },
      });

      const noteFormValid = useMemo(() => {
        return (
          // noteFormik.values.to !== "" &&
          // noteFormik.values.to !== undefined &&
          noteFormik.values.subject !== "" &&
          noteFormik.values.subject !== undefined &&
          stripHtmlTags(noteFormik.values.message) !=="" &&
          stripHtmlTags(noteFormik.values.message) !==undefined 
        );
      }, [noteFormik.values.subject, noteFormik.values.message]);

    
      useEffect(() => {
        const fetchEmailLogs = async () => {
          try {
            const response = await axios.get(`${API_URL}/view-email-logs`);
            setEmailLog(response.data); // Set the fetched data to state
        
            
          } catch (error) {
            console.error("Failed to load expenses", error);
          }
        };

     
       
        fetchEmailLogs();
       
        
      }, []);

      // useEffect(() => {
      //   if (invoiceEmailData.template) {
      //     const selectedTemplate = emailTemplateList.find(
      //       (template) => template.id === Number(invoiceEmailData.template)
      //     );
    
      //     if (selectedTemplate) {
      //       setInvoiceEmailData({
      //         ...invoiceEmailData,
      //         subject: selectedTemplate.subject,
      //         message: selectedTemplate.message,
      //       });
      //     }
      //   }
      // }, [invoiceEmailData.template, invoiceEmailData.subject]); 
      


 useEffect(() => {

    const isQuoteEmail = selectedRowsQuotes.length > 0;
  const isInvoiceEmail = selectedRows.length > 0;
    // Check if there is already a selected template
    if (!invoiceEmailData.template && emailTemplateList.length > 0) {
      // Find the default template with the name "Payment Link"
      // const defaultTemplate = emailTemplateList.find(
      //   (template) => template.template_name === "Invoice"

      // );
       const defaultTemplateName = isQuoteEmail
      ? "Work Order" // or "Quote", depending on your naming
      : "Invoice";

       const defaultTemplate = emailTemplateList.find(
      (template) => template.template_name === defaultTemplateName
    );
  
      if (defaultTemplate) {
        // Set the default template
        setInvoiceEmailData({
          ...invoiceEmailData,
          template: String(defaultTemplate.id), // Set default template ID
          subject: defaultTemplate.subject, // Set subject
          message: defaultTemplate.message, // Set message
        });
      }
    }
 if (invoiceEmailData.template) {
      const selectedTemplate = emailTemplateList.find(
        (template) => template.id === Number(invoiceEmailData.template)
      );
  
      if (selectedTemplate) {
        setInvoiceEmailData({
          ...invoiceEmailData,
          subject: selectedTemplate.subject,
          message: selectedTemplate.message,
        });
      }
    }
  }, [invoiceEmailData.template, emailTemplateList]);
  
      
      useEffect(() => {
        const quote = quoteList.find((inv) => inv.id === Number(quoteId)); // Convert quoteId to number

      
        if (!quote) {
          console.error(`Work order not found for ID: ${quoteId}`);
          return;
        }
      
        // Proceed with your logic here
      }, [quoteId, quoteList]);

      useEffect(() => {
        if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
          setCurrentSearchQuery(debouncedSearchQuery);
          refetch();
        }
      }, [debouncedSearchQuery]);

      useEffect(() => {
        if (
          debouncedSearchQueryProject.length >= 4 ||
          debouncedSearchQueryProject === ""
        ) {
          setCurrentSearchQueryProject(debouncedSearchQueryProject);
          refetch();
        }
      }, [debouncedSearchQueryProject]);

      useEffect(() => {
        if (
          debouncedSearchQueryInvoice.length >= 3 ||
          debouncedSearchQueryInvoice === ""
        ) {
          setCurrentSearchQueryInvoice(debouncedSearchQueryInvoice);
          refetch();
        }
      }, [debouncedSearchQueryInvoice]);

      useEffect(() => {
        if (
          debouncedSearchQueryEmailTemplate.length >= 3 ||
          debouncedSearchQueryEmailTemplate === ""
        ) {
          setCurrentSearchQueryEmailTemplate(debouncedSearchQueryEmailTemplate);
          refetch();
        }
      }, [debouncedSearchQueryEmailTemplate]);

      useEffect(() => {
        if (
          debouncedSearchQueryNoteTemplate.length >= 3 ||
          debouncedSearchQueryNoteTemplate === ""
        ) {
          setCurrentSearchQueryNoteTemplate(debouncedSearchQueryNoteTemplate);
          refetch();
        }
      }, [debouncedSearchQueryNoteTemplate]);

      useEffect(() => {
        if (customer && customer.customerEmail || customer?.customerMobileNum) {
          emailFormik.setFieldValue("to", customer.customerEmail);
          textFormik.setFieldValue("phone_no", customer.customerMobileNum);
          setInvoiceEmailData({ ...invoiceEmailData, to: customer.customerEmail });

        }
      }, [customer]);

      const handleOpenDialog = (customer: ICustomer) => {
        setSelectCustomer(customer);
        setOpenDialog(true);
      };

      const handleCloseDialog = () => {
        setSelectCustomer(null);
        setOpenDialog(false);
      };

      const handleOpenAddTransaction = () => {
        setTransactionData(undefined);
        setOpenAddTransaction(true);
      };

      const handleCloseAddTransaction = () => {
        setTransactionData(undefined);
        setOpenAddTransaction(false);
      };

      const handleOpenAddProject = () => {
        setProjecData(undefined);
        setOpenAddProject(true);
      };

      const handleCloseAddProject = () => {
        setProjecData(undefined);
        setOpenAddProject(false);
      };

      const handleOpenViewInvoice = (transactionId: string) => {
       // console.log("Opening invoice for ID:", transactionId); // Check if this is logged
        setInvoiceId(transactionId);
        setOpenViewInvoice(true);
      };

      const handleOpenPayment = (paymentId: string) => {
        console.log(`${PAYMENT_URL}`)
        window.open(`${PAYMENT_URL}/${paymentId}`, '_blank');
       };


      
      const handleOpenViewQuote = (transactionId: string) => {
        setQuoteId(transactionId);
        setOpenViewQuote(true);
        //console.log(transactionId);
      };
      

      const handleCloseViewInvoice = () => {
        setOpenViewInvoice(false);
        setInvoiceId("");
      };

      const handleCloseViewQuote = () => {
        setOpenViewQuote(false);
        setQuoteId("");
      };

      const handleOpenAddWorkOrder = () => {
        setWorkOrderData(undefined);
        setOpenAddWorkOrder(true);
      };

      const handleCloseAddWorkOrder = () => {
        setWorkOrderData(undefined);
        setOpenAddWorkOrder(false);
      };

     

      const handleInvoiceToggle = () => {
        setShowProject(false);
        setShowInvoice(true);
        setShowEmailForm(false);
        setShowNoteForm(false);
        setShowTextForm(false);
        setShowQuotes(false);
        setShowProfileForm(false);
        setShowHistory(false);
        setShowContractInvoice(false);
      };

      const handleQuotesToggle = () => {
        setShowProject(false);
        setShowQuotes(true);
        setShowInvoice(false);
        setShowEmailForm(false);
        setShowNoteForm(false);
        setShowTextForm(false);
        setShowProfileForm(false);
        setShowHistory(false);
        setShowContractInvoice(false);
      };

      const handleProjectToggle = () => {
        setShowProject(true);
        setShowInvoice(false);
        setShowEmailForm(false);
        setShowNoteForm(false);
        setShowTextForm(false);
        setShowQuotes(false);
        setShowProfileForm(false);
        setShowHistory(false);
      };

      const handleEmailToggle = () => {
        setShowEmailForm(true);
        setShowInvoice(false);
        setShowProject(false);
        setShowNoteForm(false);
        setShowTextForm(false);
        setShowQuotes(false);
        setShowProfileForm(false);
        setShowHistory(false);
        setShowContractInvoice(false);
      };

      const handleTextToggle = () => {
        setShowEmailForm(false);
        setShowInvoice(false);
        setShowProject(false);
        setShowNoteForm(false);
        setShowTextForm(true);
        setShowQuotes(false);
        setShowProfileForm(false);
        setShowHistory(false);
        setShowContractInvoice(false);
      };

      const handleNoteToggle = () => {
        setShowEmailForm(false);
        setShowInvoice(false);
        setShowProject(false);
        setShowNoteForm(true);
        setShowTextForm(false);
        setShowQuotes(false);
        setShowProfileForm(false);
        setShowHistory(false);
        setShowContractInvoice(false);
      };

      const handleProfileToggle = () => {
        setShowProfileForm(true);
        setShowEmailForm(false);
        setShowInvoice(false);
        setShowProject(false);
        setShowNoteForm(false);
        setShowTextForm(false);
        setShowQuotes(false);
        setShowHistory(false);
        setShowContractInvoice(false);
      };

      const handleHistoryToggle = () => {
        setShowHistory(true);
        setShowProfileForm(false);
        setShowEmailForm(false);
        setShowInvoice(false);
        setShowProject(false);
        setShowNoteForm(false);
        setShowTextForm(false);
        setShowQuotes(false);
        setShowContractInvoice(false);
      };

      const handleContractInvoiceToggle = () => {
        setShowContractInvoice(true);
        setShowHistory(false);
        setShowProfileForm(false);
        setShowEmailForm(false);
        setShowInvoice(false);
        setShowProject(false);
        setShowNoteForm(false);
        setShowTextForm(false);
        setShowQuotes(false);
      };
      

      if (isLoading || customerDataIsLoading) {
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="10vh"
          >
            <CircularProgress />
          </Box>
        );
      }

      if (isError) {
        return (
          <Typography color="error">
            Error fetching customer data. Please try again later.
          </Typography>
        );
      }

      if (!customer) {
        return <Typography>No customer data available.</Typography>;
      }
      const handleOpenDeletePopup = (coursing: ICustomer) => {
        setCoursingToDelete(coursing);
        setOpenDeleteCategory(true);
      };

      const handleCloseDeletePopup = () => {
        setCoursingToDelete(null);
        setOpenDeleteCategory(false);
      };

      const handleDelete = async (id: string) => {
        try {
          const response = await deleteCategory(id).unwrap();
          if (response.status) {
            showMessage("Deleted successfully");
          navigate("/customer/list");
            setOpenDeleteCategory(false);
          } else {
            showErrorMessage("Failed to delete the customer");
          }
        } catch (error) {
          showErrorMessage("Failed to delete the customer");
        }
      };

      

      const handleOpenDeleteProjectPopup = (project: ICustomerProject) => {
        setProjectToDelete(project);
        setOpenDeleteProject(true);
      };

      const handleCloseDeleteProjectPopup = () => {
        setProjectToDelete(null);
        setOpenDeleteProject(false);
      };

      const handleDeleteProject = async (id: string) => {
        try {
          const response = await deleteProject(id).unwrap();
          if (response.status) {
            showMessage("Deleted successfully");
            setOpenDeleteProject(false);
            const refetchResult = await refetchActivityHistory();
          } else {
            showErrorMessage("Failed to delete the customer project");
          }
        } catch (error) {
          showErrorMessage("Failed to delete the customer project");
        }
      };

      const handleOpenDeleteWrokOrderPopup = (project: IQuoteWorkOrder) => {
        setProjectWrokOrderToDelete(project);
        setOpenDeleteProjectWrokOrder(true);
      };

      const handleCloseDeleteWrokOrderPopup = () => {
        setProjectWrokOrderToDelete(null);
        setOpenDeleteProjectWrokOrder(false);
      };

      const handleDeleteWrokOrder = async (id: string) => {
        try {
          const temData = {
            id: id,
            quoteWorkOrderCustomerId: String(customerId),
          };
          const response = await newCustomer(temData).unwrap();

          if (response.status) {
            showMessage("Deleted successfully");
            setOpenDeleteProjectWrokOrder(false);
          } else {
            showErrorMessage("Failed to remove the customer project work order");
          }
        } catch (error) {
          showErrorMessage("Failed to remove the customer project remove");
        }
      };

      const emailLogs = activityHistoryData?.data?.emailLogs || [];
      const smsLogs = activityHistoryData?.data?.smsLogs || [];
      const noteLogs = activityHistoryData?.data?.noteLogs || [];
      const notes = activityHistoryData?.data?.notes || [];
      const projectLogs = activityHistoryData?.data?.projectLogs || [];
      const customerProfileLogs = activityHistoryData?.data?.customerProfileLogs || [];
      const processedWorkOrderIds = new Set();
    
      const combinedLogs = [
        ...emailLogs.map((log) => ({
          ...log,
          type: "Email Sent",
        })),
        ...smsLogs.map((log) => ({
          ...log,
          type: "Sms Sent",
        })),
        ...noteLogs.map((log) => ({
          ...log,
          type: "Note Email Sent",
        })),
        ...notes.map((log) => ({
          ...log,
          type: "Note Saved",
        })),

                         
        ...(workOrderHistoryData &&
            Array.isArray(workOrderHistoryData.data) &&
            workOrderHistoryData.data.length > 0
              ? workOrderHistoryData.data.map((log, workOrderIndex) => {
                // const type =
                // workOrderIndex === 0
                // ? "Work order created"
                // : log.isInvoice
                // ? "Work order converted to invoice"
                // : "Work order edited";
                let type = "";
               
                if (!processedWorkOrderIds.has(log.work_order_id)) {
                  type = "Quote created";
                  processedWorkOrderIds.add(log.work_order_id);
                } else if (log.isInvoice) {
                  type = "Quote converted to invoice";
                } else {
                  type = "Quote edited";
                }
              
          return {
            ...log,
            type, // Use the determined type
            workOrderIndex,
          };
        })
        : []),

        // ...(workOrderHistoryData &&
        //   Array.isArray(workOrderHistoryData.data) &&
        //   workOrderHistoryData.data.length > 0
        //     ? workOrderHistoryData.data.map((order, index) => {
        //         const label =
        //       index === 0
        //         ? "Work order created"
        //         : order.isInvoice
        //         ? "Work order converted to invoice"
        //         : "Work order edited";
    
        //     const description = (
        //       <div>
        //         {index === 0 && (
        //           <div>
        //             <Typography variant="body1">
        //               <strong>Created by :</strong> {order.updated_by}
        //             </Typography>
        //             <Typography variant="body1">
        //               <strong>Created at :</strong>{" "}
        //               {order?.created_at
        //                 ? dayjs(order.created_at).format("MMMM D, YYYY [at] h:mm A")
        //                 : ""}
        //             </Typography>
        //           </div>
        //         )}
    
        //         {order.isInvoice == true && (
        //           <div>
        //             <Typography variant="body1">
        //               <strong>Invoice Number :</strong> {order.InvoiceNo}
        //             </Typography>
        //             <Typography variant="body1">
        //               <strong>Converted by :</strong> {order.updated_by}
        //             </Typography>
        //             <Typography variant="body1">
        //               <strong>Converted at :</strong>{" "}
        //               {order?.created_at
        //                 ? dayjs(order.created_at).format("MMMM D, YYYY [at] h:mm A")
        //                 : ""}
        //             </Typography>
        //             <Grid item textAlign={"end"} justifyContent={"flex-end"}>
        //               <Button
        //                 variant="contained"
        //                 startIcon={<VisibilitySharpIcon />}
        //                 className={classes.addButton}
        //                 onClick={() =>
        //                   navigate(
        //                     `/invoice/history/${WorkOrderDataList?.invoiceId}`
        //                   )
        //                 }
        //               >
        //                 Invoice
        //               </Button>
        //             </Grid>
        //           </div>
        //         )}
        //         {order.isInvoice == false && index != 0 && (
        //           <div>
        //             <Typography variant="body1">
        //               <strong>Edited by :</strong> {order.updated_by}
        //             </Typography>
        //             <Typography variant="body1">
        //               <strong>Edited at :</strong>{" "}
        //               {order?.updated_at
        //                 ? dayjs(order.updated_at).format("MMMM D, YYYY [at] h:mm A")
        //                 : ""}
        //             </Typography>
        //           </div>
        //         )}
        //         <Typography variant="body1"> </Typography>
        //         <TableContainer sx={{ marginTop: 2 }}>
        //           <Table className={classes.table}>
        //             <TableHead className={classes.tableHeaderRow}>
        //               <TableRow>
        //                 <TableCell className={classes.tablheader}>
        //                   <strong>Product</strong>
        //                 </TableCell>
                       
        //                 <TableCell
        //                   className={classes.tablheader}
        //                   sx={{ textAlign: "right" }}
        //                 >
        //                   <strong>Price</strong>
        //                 </TableCell>
        //                 <TableCell
        //                   className={classes.tablheader}
        //                   sx={{ textAlign: "right" }}
        //                 >
        //                   <strong>Tax</strong>
        //                 </TableCell>
                     
        //                 <TableCell
        //                   className={classes.tablheader}
        //                   sx={{ textAlign: "right" }}
        //                 >
        //                   <strong>Total</strong>
        //                 </TableCell>
        //               </TableRow>
        //             </TableHead>
        //             <TableBody>
        //               {workOrderError || order.quoteWorkOrderSale.length === 0 ? (
        //                 <TableRow>
        //                   <TableCell colSpan={8} align="center">
        //                     {workOrderError
        //                       ? "Error fetching data"
        //                       // : "No data available"
        //                       :""
        //                       }
        //                   </TableCell>
        //                 </TableRow>
        //               ) : (
        //                 order.quoteWorkOrderSale.map(
        //                   (
        //                     row: IProduct,
        //                     index: number 
        //                   ) => (
        //                     <TableRow key={index} className={classes.tableRowHover}>
        //                       <TableCell scope="row" className={classes.tablCell}>
        //                         {row.productName}
        //                       </TableCell>
        //                       {/* <TableCell className={classes.tablCell} align="right">
        //                         {row.quantity}
        //                       </TableCell> */}
        //                       <TableCell className={classes.tablCell} align="right">
        //                         {row.price !== null && row.price !== undefined
        //                           ? row.price.toFixed(2)
        //                           : "0.00"}
        //                       </TableCell>
        //                       <TableCell className={classes.tablCell} align="right">
        //                         {/* {row.tax}% */}
        //                         {row.taxAmount}
        //                       </TableCell>
        //                       {/* <TableCell className={classes.tablCell} align="right">
        //                         {(row.unitPriceWithDiscount ?? 0).toFixed(2)}
        //                       </TableCell> */}
        //                       <TableCell className={classes.tablCell} align="right">
        //                         {row.unitTotalWithDiscount != null
        //                           ? row.unitTotalWithDiscount.toFixed(2)
        //                           : "0.00"}
        //                       </TableCell>
        //                     </TableRow>
        //                   )
        //                 )
        //               )}
        //             </TableBody>
        //           </Table>
        //         </TableContainer>
        //         <Grid container>
        //           {workOrderError ||
        //           order.quoteWorkOrderSaleDiscountDescription.length === 0 ? (
        //             <Grid item lg={12} md={12} sm={12} xs={12}>
        //               {workOrderError ? "Error fetching data" 
        
        //                 // : "No data available"
        //                       :""
        //               }
        //             </Grid>
        //           ) : (
        //             order.quoteWorkOrderSaleDiscountDescription.map(
        //               (discount: IDiscount, index: number) => (
        //                 <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
        //                   <Grid
        //                     container
        //                     spacing={2}
        //                     display={"end"}
        //                     justifyContent={"flex-end"}
        //                   >
        //                     <Grid
        //                       item
        //                       lg={2}
        //                       md={2}
        //                       sm={4}
        //                       xs={8}
        //                       textAlign={"end"}
        //                     >
        //                       <Typography>
        //                         {discount.description || "Discount"}
        //                         {" :"}
        //                       </Typography>
        //                     </Grid>
        //                     <Grid
        //                       item
        //                       lg={2}
        //                       md={2}
        //                       sm={2}
        //                       xs={4}
        //                       textAlign={"end"}
        //                     >
        //                       <Typography>
        //                         {"$"}
        //                         {(discount.value ?? 0).toFixed(2)}
        //                       </Typography>
        //                     </Grid>
        //                   </Grid>
        //                 </Grid>
        //               )
        //             )
        //           )}
        //           <Grid item lg={12} md={12} sm={12} xs={12}>
        //             <Grid
        //               container
        //               spacing={2}
        //               display={"end"}
        //               justifyContent={"flex-end"}
        //             >
        //               <Grid
        //                 item
        //                 lg={2}
        //                 md={2}
        //                 sm={4}
        //                 xs={8}
        //                 textAlign={"end"}
        //                 className={classes.tablCell}
        //               >
        //                 <Typography>Total Discount :</Typography>
        //               </Grid>
        //               <Grid
        //                 item
        //                 lg={2}
        //                 md={2}
        //                 sm={2}
        //                 xs={4}
        //                 textAlign={"end"}
        //                 className={classes.tablCell}
        //               >
        //                 <Typography>
        //                   {"$"}
        //                   {Number(order.quoteWorkOrderDiscount || 0).toFixed(2)}
        //                 </Typography>
        //               </Grid>
        //             </Grid>
        //           </Grid>
        //           <Grid item lg={12} md={12} sm={12} xs={12}>
        //             <Grid
        //               container
        //               spacing={2}
        //               display={"end"}
        //               justifyContent={"flex-end"}
        //             >
        //               <Grid item lg={2} md={2} sm={4} xs={8} textAlign={"end"}>
        //                 <Typography style={{fontWeight:'bold'}}>
        //                   Grand Total :
        //                 </Typography>
        //               </Grid>
        //               <Grid item lg={2} md={2} sm={2} xs={4} textAlign={"end"}>
        //                 <Typography style={{fontWeight:'bold'}} >
        //                   {"$"}
        //                   {Number(order.quoteWorkOrderSaleGrandTotal || 0).toFixed(
        //                     2
        //                   )}
        //                 </Typography>
        //               </Grid>
        //             </Grid>
        //           </Grid>
        //         </Grid>
        //       </div>
        //     );
        //     return {
        //       label,
        //       description,
        //       type: label, // Use the label as the type for consistency
        //     };
        //   })
        // : []),


        ...projectLogs.map((log) => {
          // Determine the type based on the action performed
          let type = "Project Created"; // Default to Created
          if (log.action === "updated") {
            type = "Project Updated";
          } else if (log.action === "deleted") {
            type = "Project Deleted";
          }
          return {
            ...log,
            type,
          };
        }),

        ...customerProfileLogs.map((log) => ({
          ...log,
          type: log.action === "created" ? "Client Profile Created" : "Client Profile Updated",
        })),

      ];

      const sortedCombinedLogs = combinedLogs.sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateB - dateA; // Sort descending
      });
      
      // Create timeLineSteps from sorted logs
      const timeLineSteps = sortedCombinedLogs.map((log, index) => {
        let description;
      
        if (log.type === "Client Profile Created") {
          description = (
            <div>
              <Typography variant="body1">
                <strong>Created by:</strong> {log.username || "—"}
              </Typography>
              <Typography variant="body1">
                <strong>Created at:</strong>{" "}
                {log.created_at ? dayjs(log.created_at).format("MMM D, YYYY [at] h:mm A") : "—"}
              </Typography>
            </div>
          );
        } else if (log.type === "Client Profile Updated") {
          description = (
            <div>
              <Typography variant="body1">
                <strong>Updated by:</strong> {log.username || "—"}
              </Typography>
              <Typography variant="body1">
                <strong>Updated at:</strong>{" "}
                {log.created_at ? dayjs(log.created_at).format("MMM D, YYYY [at] h:mm A") : "—"}
              </Typography>
            </div>
          );
        } else if (log.type === "Sms Sent") {
          description = `Message | ${log.message || 'N/A'}`;
        } else if (log.type.startsWith("Project")) {
        
          if (log.type === "Project Created") {
            description = `Project '${log.project_name}' has been created `;
        } else if (log.type === "Project Updated") {
            description = `Project '${log.project_name}' has been updated`;
        } else if (log.type === "Project Deleted") {
            description = `Project '${log.project_name}'  has been deleted`;
        } 
    
        }   else if  (log.type.startsWith("Quote")) {
         // description = `Work order '${log.quoteWorkOrderNo}' has been created `;

             description = (
              <div>
                
                {log.type === "Quote created" && (
                // {log.workOrderIndex  === 0 && (
                  <div>
                     <Typography variant="body1">
                    <strong>Quote No. :</strong> {log.quoteWorkOrderNo}
                  </Typography>
                    <Typography variant="body1">
                      <strong>Created by :</strong> {log.updated_by}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Created at :</strong>{" "}
                      {log?.created_at
                        ? dayjs(log.created_at).format("MMM D, YYYY [at] h:mm A")
                        : ""}
                    </Typography>
                  </div>
                )}
                  {log.type === "Quote converted to invoice" && (
                //{log.isInvoice == true && (
                  <div>
                    <Typography variant="body1">
                      <strong>Invoice Number :</strong> {log.InvoiceNo}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Converted by :</strong> {log.updated_by}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Converted at :</strong>{" "}
                      {log?.created_at
                        ? dayjs(log.created_at).format("MMM D, YYYY [at] h:mm A")
                        : ""}
                    </Typography>
                    <Grid item textAlign={"end"} justifyContent={"flex-end"}>
                      <Button
                        variant="contained"
                        startIcon={<VisibilitySharpIcon />}
                        className={classes.addButton}
                        onClick={() =>
                          navigate(
                            `/invoice/history/${log?.invoiceId}`
                          )
                        }
                      >
                        Invoice
                      </Button>
                    </Grid>
                  </div>
                )}
                {/* {log.isInvoice == false && log.workOrderIndex != 0 && ( */}
                  {log.isInvoice == false && log.type === "Quote edited" && (
                  <div>
                     <Typography variant="body1">
                    <strong>Quote No. :</strong> {log.quoteWorkOrderNo}
                  </Typography>
                    <Typography variant="body1">
                      <strong>Edited by :</strong> {log.updated_by}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Edited at :</strong>{" "}
                      {log?.updated_at
                        ? dayjs(log.updated_at).format("MMM D, YYYY [at] h:mm A")
                        : ""}
                    </Typography>
                  </div>
                )}
                <Typography variant="body1"> </Typography>
                <TableContainer sx={{ marginTop: 2 }}>
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow>
                        <TableCell className={classes.tablheader}>
                          <strong>Product</strong>
                        </TableCell>
                       
                        <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Price</strong>
                        </TableCell>
                        {/* <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Tax</strong>
                        </TableCell>
                     
                        <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Total</strong>
                        </TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {workOrderError || log.quoteWorkOrderSale.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={8} align="center">
                            {workOrderError
                              ? "Error fetching data"
                              // : "No data available"
                              :""
                              }
                          </TableCell>
                        </TableRow>
                      ) : (
                        log.quoteWorkOrderSale.map(
                          (
                            row: IProduct,
                            index: number 
                          ) => (
                            <TableRow key={index} className={classes.tableRowHover}>
                              <TableCell scope="row" className={classes.tablCell}>
                                {row.productName}
                              </TableCell>
                              {/* <TableCell className={classes.tablCell} align="right">
                                {row.quantity}
                              </TableCell> */}
                              <TableCell className={classes.tablCell} align="right">
                                {row.price !== null && row.price !== undefined
                                  ? row.price.toFixed(2)
                                  : "0.00"}
                              </TableCell>
                              {/* <TableCell className={classes.tablCell} align="right">
                               
                                {row.taxAmount}
                              </TableCell> */}
                              {/* <TableCell className={classes.tablCell} align="right">
                                {(row.unitPriceWithDiscount ?? 0).toFixed(2)}
                              </TableCell> */}
                              {/* <TableCell className={classes.tablCell} align="right">
                                {row.unitTotalWithDiscount != null
                                  ? row.unitTotalWithDiscount.toFixed(2)
                                  : "0.00"}
                              </TableCell> */}
                            </TableRow>
                          )
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Grid container>
                  {workOrderError ||
                  log.quoteWorkOrderSaleDiscountDescription.length === 0 ? (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      {workOrderError ? "Error fetching data" 
        
                        // : "No data available"
                              :""
                      }
                    </Grid>
                  ) : (
                    log.quoteWorkOrderSaleDiscountDescription.map(
                      (discount: IDiscount, index: number) => (
                        <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
                          <Grid
                            container
                            spacing={2}
                            display={"end"}
                            justifyContent={"flex-end"}
                          >
                            <Grid
                              item
                              lg={2}
                              md={2}
                              sm={4}
                              xs={8}
                              textAlign={"end"}
                            >
                              <Typography>
                                {discount.description || "Discount"}
                                {" :"}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={2}
                              md={2}
                              sm={2}
                              xs={4}
                              textAlign={"end"}
                            >
                              <Typography>
                                {"$"}
                                {(discount.value ?? 0).toFixed(2)}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      )
                    )
                  )}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      spacing={2}
                      display={"end"}
                      justifyContent={"flex-end"}
                    >
                      <Grid
                        item
                        lg={2}
                        md={2}
                        sm={4}
                        xs={8}
                        textAlign={"end"}
                        className={classes.tablCell}
                      >
                        <Typography>Total Discount :</Typography>
                      </Grid>
                      <Grid
                        item
                        lg={2}
                        md={2}
                        sm={2}
                        xs={4}
                        textAlign={"end"}
                        className={classes.tablCell}
                      >
                        <Typography>
                          {"$"}
                          {Number(log.quoteWorkOrderDiscount || 0).toFixed(2)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      spacing={2}
                      display={"end"}
                      justifyContent={"flex-end"}
                    >
                      <Grid item lg={2} md={2} sm={4} xs={8} textAlign={"end"}>
                        <Typography style={{fontWeight:'bold'}}>
                          Grand Total :
                        </Typography>
                      </Grid>
                      <Grid item lg={2} md={2} sm={2} xs={4} textAlign={"end"}>
                        <Typography style={{fontWeight:'bold'}} >
                          {"$"}
                          {Number(log.quoteWorkOrderSaleGrandTotal || 0).toFixed(
                            2
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            );




        } else {
          description = `Subject | ${log.subject || 'No Subject'}`; // Default for emails and note emails
        }

        const rawHtml =
          (log.type === 'Email Sent' || log.type === 'Note Email Sent') && log.message
            ? log.message
            : null;

        return {
          key: `${log.type}-${log.created_at}-${log.id || index}`,
          label: log.type,
          description, // Use the customized description
          rawHtml,
          date: new Date(log.created_at).toLocaleDateString(),
          time: new Date(log.created_at).toLocaleTimeString(),
        };
      });




      // const timeLineSteps = [
      //   {
      //     label: "Project Initiated",
      //     description: "The project was initiated on January 1st, 2024.",
      //     date: "January 1st, 2024",
      //     time: "10:00 AM",
      //   },
      //   {
      //     label: "Requirement Gathering",
      //     description:
      //       "All project requirements were gathered by January 15th, 2024.",
      //     date: "January 15th, 2024",
      //     time: "2:00 PM",
      //   },
      //   {
      //     label: "Design Phase",
      //     description: "Design phase started on February 1st, 2024.",
      //     date: "February 1st, 2024",
      //     time: "9:30 AM",
      //   },
      //   {
      //     label: "Development Phase",
      //     description: "Development phase started on March 1st, 2024.",
      //     date: "March 1st, 2024",
      //     time: "11:00 AM",
      //   },
      //   {
      //     label: "Testing Phase",
      //     description: "Testing phase started on April 1st, 2024.",
      //     date: "April 1st, 2024",
      //     time: "3:45 PM",
      //   },
      //   {
      //     label: "Project Completed",
      //     description: "The project was successfully completed on May 1st, 2024.",
      //     date: "May 1st, 2024",
      //     time: "5:00 PM",
      //   },
      // ];

      const toggleStepDetails = (index: number) => {
        if (expandedSteps.includes(index)) {
          setExpandedSteps(
            expandedSteps.filter((stepIndex) => stepIndex !== index)
          );
        } else {
          setExpandedSteps([...expandedSteps, index]);
        }
      };

      const convertPlainTextToHTML= (text: string) => {
        return text
          .replace(/\n/g, '<br>') // Replace line breaks with <br>
          .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length)); // Replace multiple spaces with &nbsp;
      }
      const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsSendAsEmail(event.target.checked); // Toggle the state when switch is changed
      };
    


      
    

      return (
        <div>
          <Grid container spacing={3}>
            <Grid item lg={8} md={8} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card sx={{
                    borderRadius: 3,
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                  }}>
                    {/* Gradient Banner */}
                    <Box sx={{
                      background: 'rgb(46, 55, 145)',
                      px: 3, pt: 3, pb: 0,
                    }}>
                      {/* Top row: avatar + name + contact */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5, mb: 2.5 }}>
                        {/* Avatar */}
                        <Box sx={{ position: 'relative' }}>
                          {customer.customerImg ? (
                            <Avatar
                              src={`${LARAVEL_API_URL}/${customer.customerImg}`}
                              sx={{ width: 80, height: 80, border: '3px solid rgba(255,255,255,0.6)', boxShadow: '0 4px 14px rgba(0,0,0,0.3)' }}
                            />
                          ) : (
                            <Avatar sx={{
                              width: 80, height: 80,
                              fontSize: '2rem', fontWeight: 700,
                              bgcolor: 'rgba(255,255,255,0.2)',
                              border: '3px solid rgba(255,255,255,0.5)',
                              color: 'white',
                              boxShadow: '0 4px 14px rgba(0,0,0,0.3)',
                            }}>
                              {(customer.customerFirstName || customer.customerCompanyName)?.charAt(0).toUpperCase() ?? '?'}
                            </Avatar>
                          )}
                        </Box>

                        {/* Name + Contact */}
                        <Box sx={{ flex: 1 }}>
                          {customer.customerFirstName && (
                            <Typography variant="h4" sx={{ color: 'white', fontWeight: 700, lineHeight: 1.2, mb: 0.5, textTransform: 'capitalize' }}>
                              {[customer.customerFirstName, customer.customerLastName].filter((s) => s && s.trim() && s.trim().toLowerCase() !== "null").map((s) => s!.trim()).join(" ")}
                            </Typography>
                          )}
                          {customer.customerCompanyName && (
                            <Typography variant={customer.customerFirstName ? 'body1' : 'h4'} sx={{ color: customer.customerFirstName ? 'rgba(255,255,255,0.8)' : 'white', fontWeight: customer.customerFirstName ? 400 : 700, mb: 0.5, textTransform: 'capitalize' }}>
                              {customer.customerCompanyName}
                            </Typography>
                          )}
                          {!customer.customerFirstName && !customer.customerCompanyName && (
                            <Typography variant="h4" sx={{ color: 'rgba(255,255,255,0.5)', fontWeight: 700, lineHeight: 1.2, mb: 0.5 }}>
                              No Name
                            </Typography>
                          )}
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
                            {customer.customerMobileNum && (
                              <Chip
                                icon={<PhoneIcon style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14 }} />}
                                label={customer.customerMobileNum}
                                size="small"
                                sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white', fontSize: '0.75rem', height: 26,
                                  '& .MuiChip-icon': { color: 'rgba(255,255,255,0.85)' } }}
                              />
                            )}
                            {customer.customerEmail && (
                              <Chip
                                icon={<EmailIcon style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14 }} />}
                                label={customer.customerEmail}
                                size="small"
                                sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white', fontSize: '0.75rem', height: 26,
                                  '& .MuiChip-icon': { color: 'rgba(255,255,255,0.85)' } }}
                              />
                            )}
                            {customer.customerCity && (
                              <Chip
                                icon={<HomeIcon style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14 }} />}
                                label={[customer.customerCity, customer.customerProvince].filter(Boolean).join(', ')}
                                size="small"
                                sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white', fontSize: '0.75rem', height: 26,
                                  '& .MuiChip-icon': { color: 'rgba(255,255,255,0.85)' } }}
                              />
                            )}
                          </Box>
                        </Box>

                        {/* Edit / Delete quick actions */}
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Tooltip title="Edit Profile" arrow>
                            <Box
                              onClick={() => handleOpenDialog(customer)}
                              sx={{ width: 36, height: 36, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                bgcolor: 'rgba(255,255,255,0.15)', cursor: 'pointer', color: 'white',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.28)' }, transition: 'all 0.2s' }}
                            >
                              <EditSharpIcon sx={{ fontSize: 16 }} />
                            </Box>
                          </Tooltip>
                        </Box>
                      </Box>

                      {/* Tab Bar */}
                      <Box sx={{ display: 'flex', gap: 0, overflowX: 'auto', '&::-webkit-scrollbar': { display: 'none' } }}>
                        {[
                          { label: 'Quotes', icon: <DescriptionIcon sx={{ fontSize: 18 }} />, onClick: handleQuotesToggle, active: showQuotes },
                          { label: 'Invoice', icon: <ReceiptIcon sx={{ fontSize: 18 }} />, onClick: handleInvoiceToggle, active: showInvoice },
                          { label: 'Contract Invoice', icon: <RequestPageOutlinedIcon sx={{ fontSize: 18 }} />, onClick: handleContractInvoiceToggle, active: showContractInvoice },
                          { label: 'Email', icon: <EmailIcon sx={{ fontSize: 18 }} />, onClick: handleEmailToggle, active: showEmailForm },
                          { label: 'SMS', icon: <ChatIcon sx={{ fontSize: 18 }} />, onClick: handleTextToggle, active: showTextForm },
                          { label: 'Note', icon: <NoteIcon sx={{ fontSize: 18 }} />, onClick: handleNoteToggle, active: showNoteForm },
                          { label: 'History', icon: <HistoryIcon sx={{ fontSize: 18 }} />, onClick: handleHistoryToggle, active: showHistory },
                          { label: 'Profile', icon: <PersonIcon sx={{ fontSize: 18 }} />, onClick: handleProfileToggle, active: showProfileForm },
                        ].map((tab) => (
                          <Box
                            key={tab.label}
                            onClick={tab.onClick}
                            sx={{
                              display: 'flex', alignItems: 'center', gap: 0.8,
                              px: 2.5, py: 1.5,
                              cursor: 'pointer',
                              color: tab.active ? 'white' : 'rgba(255,255,255,0.55)',
                              borderBottom: tab.active ? '3px solid #fff' : '3px solid transparent',
                              bgcolor: tab.active ? 'rgba(255,255,255,0.1)' : 'transparent',
                              fontWeight: tab.active ? 600 : 400,
                              transition: 'all 0.18s',
                              whiteSpace: 'nowrap',
                              '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.1)' },
                            }}
                          >
                            {tab.icon}
                            <Typography variant="body2" sx={{ fontWeight: 'inherit', color: 'inherit', fontSize: '0.82rem' }}>
                              {tab.label}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Card>
                </Grid>
                {showProject && (
                  <>
                    {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Projects
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CiSearch
                                          className={classes.searchWidgetIcon}
                                        />
                                      </InputAdornment>
                                    ),
                                    classes: {
                                      root: classes.formControlList,
                                    },
                                  }}
                                  fullWidth
                                  value={searchQueryProject}
                                  onChange={(e) =>
                                    setSearchQueryProject(e.target.value)
                                  }
                                  placeholder="Name .."
                                  sx={{ width: "100%" }}
                                  size="small"
                                />
                              </Grid>

                              <Grid item>
                                <Button
                                  variant="contained"
                                  className={classes.addButton}
                                  onClick={handleOpenAddProject}
                                >
                                  Add Project
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid>
                          <TableContainer>
                            <Table className={classes.table}>
                              <TableHead className={classes.tableHeaderRow}>
                                <TableRow>
                                  <TableCell className={classes.tablheader}>
                                    <strong>Project Name</strong>
                                  </TableCell>
                                  <TableCell className={classes.tablheader}>
                                    <strong>Created Date</strong>
                                  </TableCell>

                                  <TableCell
                                    className={classes.tablheader}
                                    sx={{ textAlign: "right" }}
                                  >
                                    <strong>Actions</strong>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {project.map((project) => (
                                  <TableRow
                                    key={project.id}
                                    className={classes.tableRowHover}
                                  >
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      {project.projectName}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      {project?.created_at
                                        ? dayjs(project.created_at).format(
                                            "MMM D, YYYY [at] h:mm A"
                                          )
                                        : ""}
                                    </TableCell>
                                    <TableCell className={classes.tablCell}>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid item>
                                          <Button
                                            variant="contained"
                                            className={classes.viewButtonList}
                                            onClick={() =>
                                              navigate(
                                                `/customer-history/project/${project.id}`
                                              )
                                            }
                                          >
                                            <VisibilitySharpIcon
                                              className={classes.viewListIcon}
                                            />
                                          </Button>
                                        </Grid>

                                        
                                        <Grid item>
                                          <Button
                                            variant="contained"
                                            className={classes.editButtonList}
                                            onClick={() => {
                                              setProjecData(project);
                                              setOpenAddProject(true);
                                            }}
                                          >
                                            <EditSharpIcon
                                              className={classes.editListIcon}
                                            />
                                          </Button>
                                        </Grid>
                                        <Grid item>
                                          <Button
                                            variant="contained"
                                            className={classes.deleteButtonList}
                                            onClick={() =>
                                              handleOpenDeleteProjectPopup(project)
                                            }
                                          >
                                            <DeleteOutlineSharpIcon
                                              className={classes.deleteListIcon}
                                            />
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>

                          {openAddProject && (
                            <AddProject
                              openModel={openAddProject}
                              handleCloseDialog={handleCloseAddProject}
                              data={projectData}
                              customerId={customerId}
                            />
                          )}
                          {projectToDelete && (
                            <DeletePopup
                              open={openDeleteProject}
                              handleCloseDelete={handleCloseDeleteProjectPopup}
                              onConfirm={async () => {
                                await handleDeleteProject(
                                  projectToDelete.id.toString()
                                );
                              }}
                              title="Delete Project"
                              content={`Are you sure you want to delete "${projectToDelete.projectName}"?`}
                            />
                          )}
                        </Grid>
                      </Card>
                    </Grid> */}

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Invoices
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CiSearch
                                          className={classes.searchWidgetIcon}
                                        />
                                      </InputAdornment>
                                    ),
                                    classes: {
                                      root: classes.formControlList,
                                    },
                                  }}
                              fullWidth
                              value={searchQueryInvoice}
                              onChange={(e) =>
                                setSearchQueryInvoice(e.target.value)
                              }
                              placeholder="Name .."
                              sx={{ width: "100%" }}
                              size="small"
                            />
                          </Grid>

                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.addButton}
                              onClick={() =>
                                navigate(`/quote/create/${customerId}?asInvoice=true`)
                              }
                            >
                              Create Invoice
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid>
                      <TableContainer>
                        <Table sx={{
    width: "100%",
    marginBottom: "1.5rem",
    verticalAlign: "top",
    "& > :not(caption) > * > *": {
      padding: "5px", // Ensure custom padding is applied
    },}}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                          
                              <TableCell className={classes.tablheader}>
                                <strong>Charter No</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Status</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Amount</strong>
                              </TableCell>
                               <TableCell className={classes.tablheader}>
                                 <strong>Paid Amt</strong>
                                 </TableCell>
                                  <TableCell className={classes.tablheader}>
                                 <strong>Balance</strong>
                               </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Created Date</strong>
                              </TableCell>
                            
                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "right" }}
                              >
                                <strong>Actions</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoiceList.map((transaction) => {
                                const statusLabel = getStatusLabel(transaction.quoteWorkOrderStatus);
                                const statusColor = getStatusColor(transaction.quoteWorkOrderStatus);
             const balance = Math.max(0, parseFloat(transaction.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(transaction.amount_paid || "0")));
                                return(
                              <TableRow
                                key={transaction.id}
                                className={classes.tableRowHover}
                              >
                              
                               <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                  sx={{ whiteSpace: "nowrap", cursor: "pointer" }}
                                  onClick={() => navigate(`/work-order/history/${transaction.work_order_id}`)} 
                                >
                                  {transaction.InvoiceNo}
                                   {getStatusLabel(transaction.quoteWorkOrderStatus) != 'Paid' && transaction.payment_id && (
                               <span
                                 style={{
                                   backgroundColor: '#007BFF',
                                   color: '#fff',
                                   borderRadius: '12px',
                                   padding: '2px 8px',
                                   marginLeft: '8px',
                                   fontSize: '0.7rem',
                                   fontWeight: '500',
                                   cursor: 'pointer',
                                 }}
                                // onClick={() => handleOpenPayment(String(transaction.payment_id))}
                                 onClick={() =>
                                  navigate(`/work-order/history/${transaction.work_order_id}`)
                                }
                               >
                               Pay
                               </span>
                             )}
                                </TableCell>

                               <TableCell scope="row" className={classes.tablCell}>
                               <Button
                                                             className={classes.statusButtonList}
                                                            style={{
                                                        color: statusColor,
                                                          backgroundColor: transaction.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                                       ? "#e1f8d5"
                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                                      ? "#f8d7da"
                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                                       ? "lightyellow"
                                                        : transaction.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                                        ? "#e2fafa"
                                                        : "#ffffff", // Fallback for other statuses
                                                        border: "solid 1px",
                                                        borderColor: statusColor,
                                                        borderRadius: "8px",
                                                                                      
                                                         }}
                                                           >
                                                           {statusLabel}
                                                            </Button>
                                                       </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {"$"}
                                  {parseFloat(
                                    transaction?.quoteWorkOrderSaleGrandTotal ||
                                      "0"
                                  ).toFixed(2)}
                                </TableCell>

                                    <TableCell  component="th" scope="row"  className={classes.tablCell}>
                                                            {"$"}{(transaction.amount_paid || "0" )}
                                                        </TableCell>
                                                       
                                                        <TableCell component="th" scope="row" className={classes.tablCell}>
                                                         {"$"}{balance.toFixed(2)}
                                                         </TableCell>


                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {transaction?.created_at
                                    ? dayjs(transaction.created_at).format(
                                        "MMM D, YY h:mm A"
                                      )
                                    : ""}
                                </TableCell>
                               

                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                              
                             <Grid item>
                                <Button
                                variant="contained"
                                className={classes.viewButtonList}
                                  onClick={() => handleOpenViewInvoice(String(transaction.id))}
                              >
                                <DescriptionIcon 
                                  className={classes.viewListIcon}
                                />
                              </Button>
</Grid>
                                 
                                    <Grid item>
                                      <Button
                                        variant="contained"
                                          component={Link}
                                        className={classes.viewButtonList}
                                        to={`/work-order/history/${transaction.work_order_id}`}
                                        // onClick={() =>
                                        //   navigate(
                                        //     `/work-order/history/${transaction.work_order_id}`
                                        //   )
                                        //}
                                      >
                                        <VisibilitySharpIcon
                                          className={classes.viewListIcon}
                                        />
                                    
                                      </Button>
                                    </Grid>
                               

                                    <Grid item>
                          <Button
  variant="contained"
  className={classes.editButtonList}
    component={Link}
     to={transaction.work_order_id ? `/quote-history/${transaction.work_order_id}` : `/invoice/edit/${transaction.id}`}
  // onClick={() =>
  //   navigate(
  //     transaction.project?.id
  //       ? `/invoice/project/edit/${transaction.id}` // Redirect to project-specific edit page
  //       : `/invoice/edit/${transaction.id}` // Redirect to regular edit page
  //   )
  // }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid>

                                  </Grid>
                                </TableCell>
                              </TableRow>
                              )
})}
                          </TableBody>
                        </Table>
                      </TableContainer>


                 

                      {openViewInvoice && (

  <Dialog open={openViewInvoice} onClose={handleCloseViewInvoice} maxWidth="md" fullWidth>
    <DialogTitle>
      <Typography variant="h5" component="div">Invoice Details</Typography>
    </DialogTitle>
    <DialogContent sx={{ p: 0 }}>
      <ViewWorkOrder quoteId={invoiceId} type="view" />
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseViewInvoice}>Close</Button>
    </DialogActions>
  </Dialog>

)}


                 {/* {openViewInvoice && (
                        <ViewInvoice
                          openModel={openViewInvoice}
                          handleCloseDialog={handleCloseViewInvoice}
                          invoiceId={invoiceId}
                        />
                      )} */}


                     
                    </Grid>
                  </Card>
                </Grid>



                    
                    </>

                    
                  )}


{showQuotes && (  
               
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Card className={classes.card}>
                   <Grid
                     container
                     justifyContent={"space-between"}
                     spacing={5}
                     sx={{ borderBottom: 2, padding: 2 }}
                     className={classes.titleGrid}
                   >
                     <Grid
                       item
                       lg={4}
                       md={4}
                       sm={4}
                       xs={4}
                       pt={2}
                       alignContent={"center"}
                     >
                       <Typography className={classes.cardTitle}>
                         Quotes
                       </Typography>
                     </Grid>
                     <Grid
                       item
                       lg={8}
                       md={8}
                       sm={8}
                       xs={8}
                       sx={{ display: "flex", justifyContent: "flex-end" }}
                     >
                       <Grid
                         container
                         spacing={1}
                         justifyContent="flex-end"
                         sx={{ display: "flex" }}
                       >
                         <Grid item>
                           <TextField
                             InputProps={{
                               startAdornment: (
                                 <InputAdornment position="start">
                                   <CiSearch
                                     className={classes.searchWidgetIcon}
                                   />
                                 </InputAdornment>
                               ),
                               classes: {
                                 root: classes.formControlList,
                               },
                             }}
                         fullWidth
                         value={searchQueryQuotes}
                         onChange={(e) =>
                           setSearchQueryQuotes(e.target.value)
                         }
                         placeholder="Name .."
                         sx={{ width: "100%" }}
                         size="small"
                       />
                     </Grid>

                     <Grid item>
                       <Button
                         variant="contained"
                         className={classes.addButton}
                         onClick={() =>
                           navigate(`/quote/create/${customerId}`)
                         }
                       >
                         Create Quote
                       </Button>
                     </Grid>

                   

                      {selectedRowsQuotes.length > 0 && (
                   <Grid item>
                    
      <Button disabled={pdfLoading}  variant="contained"
     className={classes.addButton} onClick={handleQuoteEmailDialogOpen}>
   {pdfLoading ? <CircularProgress size={24} /> : "Send Email"}
     </Button>
     </Grid>
   )}


                   </Grid>
                 </Grid>
               </Grid>

               <Grid>
                 <TableContainer>
                   <Table className={classes.table}>
                     <TableHead className={classes.tableHeaderRow}>
                       <TableRow>
                       <TableCell className={classes.tablheader}>
             <CustomCheckbox name="checkbox"
               onChange={handleSelectAllRowsQuotes}
               checked={selectedRowsQuotes.length === quoteList.length}
             />
           </TableCell>
         
                         <TableCell className={classes.tablheader}>
                           <strong>Quote No</strong>
                         </TableCell>
                         <TableCell className={classes.tablheader}>
                           <strong>Status</strong>
                         </TableCell>
                         <TableCell className={classes.tablheader}>
                           <strong>Amount</strong>
                         </TableCell>
                         <TableCell className={classes.tablheader}>
                           <strong>Created Date</strong>
                         </TableCell>
                        
                         <TableCell
                           className={classes.tablheader}
                           sx={{ textAlign: "right" }}
                         >
                           <strong>Actions</strong>
                         </TableCell>
                       </TableRow>
                     </TableHead>
                     <TableBody>
                       {quoteList.filter((t) => String(t.quoteWorkOrderCustomerId) === String(customerId) && !t.invoiceId).length === 0 && (
                         <TableRow>
                           <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                               <DescriptionIcon sx={{ fontSize: 48, color: '#c8d6e5' }} />
                               <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
                                 No quotes found for this client
                               </Typography>
                               <Typography variant="body2" color="text.disabled">
                                 Click "Create Quote" to add a new quote
                               </Typography>
                             </Box>
                           </TableCell>
                         </TableRow>
                       )}
                       {quoteList.filter((transaction) =>
      String(transaction.quoteWorkOrderCustomerId) === String(customerId)   &&
      !transaction.invoiceId // Only include work orders without an invoicd
    ).
                       map((transaction) =>  {
                           const statusLabel = getStatusLabel(transaction.quoteWorkOrderStatus);
                           const statusColor = getStatusColor(transaction.quoteWorkOrderStatus);
                           const invoice = invoiceList?.find((invoice) =>
                            String(invoice.id) === String(transaction.invoiceId)
                          );
                      
                          const invoiceNo = invoice ? invoice.InvoiceNo : "N/A";
                          const invoiceAmt = invoice ? invoice.quoteWorkOrderSaleGrandTotal : 0;
                          const invoiceStatus = invoice ? invoice.quoteWorkOrderStatus : null;
                          const statusForLabel = invoiceStatus === null ? 0 : invoiceStatus; 
                          const invoiceStatusLabel = getStatusLabel(statusForLabel);
                          const invoiceStatusColor = getStatusColor(statusForLabel);
                          const invoiceQuoteWorkOrderStatus = invoice ? invoice.quoteWorkOrderStatus : "N/A";
                          const amountPaid = invoice ? parseFloat(String(invoice.amount_paid) || "0") : 0;
                          const balance = invoice
                          ? Math.max(0, parseFloat(invoice.quoteWorkOrderSaleGrandTotal || "0") - amountPaid)
                          : parseFloat(transaction.quoteWorkOrderSaleGrandTotal || "0");
                          const formatAmount = (amount: number) => amount.toFixed(2);

                         return(
                         <TableRow
                           key={transaction.id}
                           className={classes.tableRowHover}
                         >
                            <TableCell component="th"
                             scope="row"
                             className={classes.tablCell}>
               
             
                        <CustomCheckbox name="checkbox" 
                   checked={selectedRowsQuotes.includes(transaction.id)}
                   onChange={() => handleSelectRowQuotes(transaction.id)}
                 />
                   </TableCell>
                        
                         <TableCell
                             component="th"
                             scope="row"
                             className={classes.tablCell}
                           >
                            <Link
    to={`/work-order/history/${transaction.id}`} // Replace with the correct path to your desired page
    style={{ textDecoration: 'none', color: 'inherit',cursor: 'pointer', }} // Optional: style to remove link styling
  >
                             {transaction.quoteWorkOrderNo}</Link>
                             {transaction.invoiceId && (
                               <span
                                 style={{
                                   backgroundColor: '#4caf50',
                                   color: '#fff',
                                   borderRadius: '12px',
                                   padding: '2px 8px',
                                   marginLeft: '8px',
                                   fontSize: '0.7rem',
                                   fontWeight: '500',
                                  //  cursor: 'pointer',
                                 }}
                                 onClick={() => handleOpenViewInvoice(String(transaction.invoiceId))}
                               >
                                {invoiceNo}
                               </span>
                             )}
                           </TableCell>
                           
                        
                           <TableCell scope="row" className={classes.tablCell}>
                           <Button
                                                             className={classes.statusButtonList}
                                                            style={{
                                                        color: statusColor,
                                                          backgroundColor: transaction.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                                       ? "#e1f8d5"
                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                                      ? "#f8d7da"
                                                      : transaction.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                                       ? "lightyellow"
                                                        : transaction.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                                        ? "#e2fafa"
                                                        : "#ffffff", // Fallback for other statuses
                                                        border: "solid 1px",
                                                        borderColor: statusColor,
                                                        borderRadius: "8px",
                                                                                      
                                                         }}
                                                           >
                                                           {statusLabel}
                                                            </Button>
                                                   </TableCell>
                                                   <TableCell   component="th" scope="row"className={classes.tablCell}>
                                                                                 {"$"}
                                                                                                      {parseFloat(invoiceAmt && !isNaN(Number(invoiceAmt))
                                                      ? invoiceAmt : transaction.quoteWorkOrderSaleGrandTotal || "0").toFixed(2)}
                                                                                                   
                                                                                                  </TableCell>
                           <TableCell
                             scope="row"
                             className={classes.tablCell}
                           >
                             {transaction?.created_at
                               ? dayjs(transaction.created_at).format(
                                   "MMM D, YYYY [at] h:mm A"
                                 )
                               : ""}
                           </TableCell>
                          

                           <TableCell
                             scope="row"
                             className={classes.tablCell}
                           >
                             <Grid
                               container
                               spacing={1}
                               sx={{
                                 display: "flex",
                                 justifyContent: "flex-end",
                               }}
                             >
                               <Grid item>
                                 <Button
                                   variant="contained"
                                   className={classes.viewButtonList}
                                   onClick={() => navigate(`/work-order/history/${transaction.id}`)}
                                   title="View Quote"
                                 >
                                   <VisibilitySharpIcon
                                     className={classes.viewListIcon}
                                   />
                                 </Button>
                               </Grid>

                               <Grid item>
                                 <Button
                                   variant="contained"
                                   className={classes.viewButtonList}
                                   onClick={() => handleOpenViewQuote(String(transaction.id))}
                                   // onClick={() =>
                                   //   navigate(
                                   //     `/invoice/history/${transaction.id}`
                                   //   )
                                   // }
                                 >
                                   <DescriptionIcon
                                     className={classes.viewListIcon}
                                   />
                                 </Button>
                               </Grid>


                               <Grid item>
                              <Button
                                variant="contained"
                                className={classes.editButtonList}
                                onClick={() =>
                                  navigate(`/quote-history/${transaction.id}`)
                                }
                              >
                                <EditSharpIcon
                                  className={classes.editListIcon}
                                />
                              </Button>
                            </Grid>
                      
                             </Grid>
                           </TableCell>
                         </TableRow>
                         )
})}
                     </TableBody>
                   </Table>
                 </TableContainer>

                







<Dialog open={showEmailDialog} onClose={handleQuoteEmailDialogClose} maxWidth="sm" fullWidth>
     <DialogTitle>Send Email
     <IconButton
 aria-label="close"
 onClick={handleQuoteEmailDialogClose}
 sx={{
   position: 'absolute',
   right: 8,
   top: 8,
   color: (theme) => theme.palette.grey[500],
 }}
>
 <CloseIcon />
</IconButton>
     </DialogTitle>
     <DialogContent>
          <Grid container spacing={1} p={"14px"}>
         <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    To
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
         size="small"
         className={classes.textField}
         InputProps={{
           sx: {
             fontSize: 14,
           },
         }}
         InputLabelProps={{
           sx: {
             fontSize: 14,
           },
           shrink: true, 
         }}
         value={invoiceEmailData.to}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
       />
         </Grid>
                             </Grid>
                           </Grid>
                           <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                    Select Template
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                               <TextField
  size="small"
  rows={4}
  className={classes.textField}
  select
  value={invoiceEmailData.template}  // Controlled by state
  onChange={(event) => {
    const selectedTemplateId = event.target.value;
    setInvoiceEmailData({
      ...invoiceEmailData,
      template: selectedTemplateId, // Update selected template
      subject: invoiceEmailData.subject, // Reset subject and message when template changes
      message: invoiceEmailData.message,
    });
  }}

    >
    <MenuItem value="">
    Select option
    </MenuItem>
    {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
     {template.template_name} {/* Display the name of the template */}
    </MenuItem>
    ))}
    </TextField>
</Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={12} md={12} sm={12} xs={12}>
                             <Grid container alignItems="center">
                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Typography variant="subtitle1">
                                   Subject
                                 </Typography>
                               </Grid>
                               <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
        size="small"
        className={classes.textField}
        InputProps={{
          sx: {
            fontSize: 14,
          },
        }}
        InputLabelProps={{
          sx: {
            fontSize: 14,
          },
        }}
         value={invoiceEmailData.subject}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
       />
       </Grid>
                             </Grid>
                           </Grid>

                           <Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    {/* Message Label */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Message</Typography>
    </Grid>

    {/* ReactQuill Editor */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <ReactQuill
        value={invoiceEmailData.message} // Bind only the message value
        onChange={(value) =>
          setInvoiceEmailData({ ...invoiceEmailData, message: value })
        } // Update message value in the state
        style={{
          height: "210px",
        }}
      />

 {/* <TextField
       size="small"
       className={classes.textField}
       InputProps={{
         sx: {
           fontSize: 14,
         },
       }}
       InputLabelProps={{
         sx: {
           fontSize: 14,
         },
       }}
         multiline
         rows={7}
         value={invoiceEmailData.message}
         onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, message: e.target.value })}
       /> */}



    </Grid>
  </Grid>
</Grid>

{/* Attachments Section */}
<Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 5 }}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1" gutterBottom>
        Attachments: {selectedRowsQuotes.length} Quote selected
      </Typography>
    </Grid>
  </Grid>
</Grid>


       
       </Grid>
     </DialogContent>
     <DialogActions>



     <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
           <Card className={classes.card}>
             <Grid container spacing={3} p={"24px"}>
               <Grid
                 item
                 lg={12}
                 md={12}
                 sm={12}
                 xs={12}
                 sx={{ display: "flex", justifyContent: "flex-end" }}
               >
               
       <Button   disabled={loading}   startIcon={<SendIcon />} 
     className={classes.addButton} onClick={handleSendEmail} variant="contained">
       {loading ? <CircularProgress size={24} /> : "Send"}
       </Button>
       </Grid>
       </Grid>
       </Card>
       </Grid>
     </DialogActions>
   </Dialog>



                 {openViewQuote && (
<Dialog open={openViewQuote} onClose={handleCloseViewQuote} maxWidth="md" fullWidth
  fullScreen={isMobile} 
>
<DialogTitle><Typography variant="h5" component="div">
Quote Details
</Typography></DialogTitle>
<DialogContent >
<ViewWorkOrder  quoteId={quoteId} type="view" /> 
</DialogContent>
<DialogActions>
 <Button onClick={handleCloseViewQuote}>Close</Button>
</DialogActions>
</Dialog>
)}

            {/* {openViewInvoice && (
                   <ViewInvoice
                     openModel={openViewInvoice}
                     handleCloseDialog={handleCloseViewInvoice}
                     invoiceId={invoiceId}
                   />
                 )} */}


                
               </Grid>
             </Card>
           </Grid>
        

               )}









{showInvoice && (  
               
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Invoices
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CiSearch
                                          className={classes.searchWidgetIcon}
                                        />
                                      </InputAdornment>
                                    ),
                                    classes: {
                                      root: classes.formControlList,
                                    },
                                  }}
                              fullWidth
                              value={searchQueryInvoice}
                              onChange={(e) =>
                                setSearchQueryInvoice(e.target.value)
                              }
                              placeholder="Name .."
                              sx={{ width: "100%" }}
                              size="small"
                            />
                          </Grid>

                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.addButton}
                              onClick={() =>
                                navigate(`/quote/create/${customerId}?asInvoice=true`)
                              }
                            >
                              Create Invoice
                            </Button>
                          </Grid>

 {selectedRows.length > 0 && (
                        <Grid item>
        <Button disabled={pdfLoading}  variant="contained"
          className={classes.addButton} onClick={handleEmailDialogOpen}>
           {pdfLoading ? <CircularProgress size={24} /> : "Send Email"}
          </Button>
          </Grid>
        )}

                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid>
                      <TableContainer>
                        <Table sx={{
    width: "100%",
    marginBottom: "1.5rem",
    verticalAlign: "top",
    "& > :not(caption) > * > *": {
      padding: "5px", // Ensure custom padding is applied
    },}}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                            <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox"
                    onChange={handleSelectAllRows}
                    checked={selectedRows.length > 0 && selectedRows.length === (invoicedWorkOrders.length > 0 ? invoicedWorkOrders.length : invoiceList.length)}
                  />
                </TableCell>
              
                              <TableCell className={classes.tablheader}>
                                <strong>Charter No</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Status</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Amount</strong>
                              </TableCell>
                                <TableCell className={classes.tablheader}>
                                <strong>Paid Amt</strong>
                                 </TableCell>
                                   <TableCell className={classes.tablheader}>
                               <strong>Balance</strong>
                                 </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Created Date</strong>
                              </TableCell>
                           
                             
                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "right" }}
                              >
                                <strong>Actions</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(invoicedWorkOrders.length === 0 && invoiceList.length === 0) && (
                              <TableRow>
                                <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
                                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                                    <ReceiptIcon sx={{ fontSize: 48, color: '#c8d6e5' }} />
                                    <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
                                      No invoices found for this client
                                    </Typography>
                                    <Typography variant="body2" color="text.disabled">
                                      Click "Create Invoice" to add a new invoice
                                    </Typography>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            )}
                            {/* Show invoiced work orders (primary source) */}
                            {invoicedWorkOrders.map((wo) => {
                              const statusLabel = getStatusLabel(wo.quoteWorkOrderStatus);
                              const statusColor = getStatusColor(wo.quoteWorkOrderStatus);
                              const grandTotal = parseFloat(wo.quoteWorkOrderSaleGrandTotal || "0");
                              const amtPaid = parseFloat(String(wo.amount_paid || "0"));
                              const balance = Math.max(0, grandTotal - amtPaid);
                              return (
                                <TableRow key={`wo-${wo.id}`} className={classes.tableRowHover} sx={{ cursor: 'pointer' }}
                                  onClick={() => navigate(`/work-order/history/${wo.id}`)}>
                                  <TableCell className={classes.tablCell}>
                                    <CustomCheckbox name="checkbox"
                                      checked={selectedRows.includes(wo.id)}
                                      onChange={(e) => { e.stopPropagation(); handleSelectRow(wo.id); }}
                                    />
                                  </TableCell>
                                  <TableCell className={classes.tablCell} sx={{ whiteSpace: 'nowrap', fontWeight: 600, color: '#1e3a5f' }}>
                                    {wo.InvoiceNo || wo.quoteWorkOrderNo}
                                    {getStatusLabel(wo.quoteWorkOrderStatus) !== 'Paid' && wo.payment_id && (
                                      <Box component="span" sx={{ bgcolor: '#0277bd', color: '#fff', borderRadius: '10px',
                                        px: 1, py: 0.2, ml: 1, fontSize: '0.68rem', fontWeight: 600 }}>
                                        Pay
                                      </Box>
                                    )}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    <Box component="span" sx={{
                                      color: statusColor,
                                      bgcolor: wo.quoteWorkOrderStatus === WorkOrderStatus.Paid ? '#e1f8d5'
                                        : wo.quoteWorkOrderStatus === WorkOrderStatus.Cancel ? '#fdecea'
                                        : wo.quoteWorkOrderStatus === WorkOrderStatus.Pending ? '#fff8e1'
                                        : wo.quoteWorkOrderStatus === WorkOrderStatus.Initiated ? '#e2fafa'
                                        : '#f5f5f5',
                                      border: `1px solid ${statusColor}`,
                                      borderRadius: '6px', px: 1, py: 0.3, fontSize: '0.75rem', fontWeight: 600,
                                    }}>
                                      {statusLabel}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.tablCell} sx={{ fontWeight: 600 }}>
                                    ${grandTotal.toFixed(2)}
                                  </TableCell>
                                  <TableCell className={classes.tablCell} sx={{ color: '#2e7d32' }}>
                                    ${amtPaid.toFixed(2)}
                                  </TableCell>
                                  <TableCell className={classes.tablCell} sx={{ color: balance > 0 ? '#e65100' : '#757575', fontWeight: balance > 0 ? 600 : 400 }}>
                                    ${balance.toFixed(2)}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    {wo.created_at ? dayjs(wo.created_at).format("MMM D, YY") : ""}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    <Grid container spacing={0.5} justifyContent="flex-end" onClick={(e) => e.stopPropagation()}>
                                      <Grid item>
                                        <Tooltip title="View Invoice" arrow>
                                          <Button variant="contained" className={classes.viewButtonList}
                                            onClick={() => handleOpenViewInvoice(String(wo.id))}>
                                            <DescriptionIcon className={classes.viewListIcon} />
                                          </Button>
                                        </Tooltip>
                                      </Grid>
                                      <Grid item>
                                        <Tooltip title="View Details" arrow>
                                          <Button variant="contained" className={classes.viewButtonList}
                                            component={Link} to={`/work-order/history/${wo.id}`}>
                                            <VisibilitySharpIcon className={classes.viewListIcon} />
                                          </Button>
                                        </Tooltip>
                                      </Grid>
                                      <Grid item>
                                        <Tooltip title="Edit Invoice" arrow>
                                          <Button variant="contained" className={classes.editButtonList}
                                            component={Link} to={`/quote-history/${wo.id}`}>
                                            <EditSharpIcon className={classes.editListIcon} />
                                          </Button>
                                        </Tooltip>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            {/* Fallback: show from invoiceList if not already covered */}
                            {invoicedWorkOrders.length === 0 && invoiceList.map((transaction) => {
                              const statusLabel = getStatusLabel(transaction.quoteWorkOrderStatus);
                              const statusColor = getStatusColor(transaction.quoteWorkOrderStatus);
                              const balance = Math.max(0, parseFloat(transaction.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(transaction.amount_paid || "0")));
                              return (
                                <TableRow key={transaction.id} className={classes.tableRowHover}>
                                  <TableCell className={classes.tablCell}>
                                    <CustomCheckbox name="checkbox"
                                      checked={selectedRows.includes(transaction.id)}
                                      onChange={() => handleSelectRow(transaction.id)} />
                                  </TableCell>
                                  <TableCell className={classes.tablCell} sx={{ whiteSpace: 'nowrap', cursor: 'pointer', fontWeight: 600 }}
                                    onClick={() => navigate(`/work-order/history/${transaction.work_order_id}`)}>
                                    {transaction?.InvoiceNo}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    <Box component="span" sx={{
                                      color: statusColor,
                                      bgcolor: transaction.quoteWorkOrderStatus === WorkOrderStatus.Paid ? '#e1f8d5'
                                        : transaction.quoteWorkOrderStatus === WorkOrderStatus.Cancel ? '#fdecea'
                                        : transaction.quoteWorkOrderStatus === WorkOrderStatus.Pending ? '#fff8e1'
                                        : '#f5f5f5',
                                      border: `1px solid ${statusColor}`, borderRadius: '6px',
                                      px: 1, py: 0.3, fontSize: '0.75rem', fontWeight: 600,
                                    }}>
                                      {statusLabel}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.tablCell} sx={{ fontWeight: 600 }}>
                                    ${parseFloat(transaction?.quoteWorkOrderSaleGrandTotal || "0").toFixed(2)}
                                  </TableCell>
                                  <TableCell className={classes.tablCell} sx={{ color: '#2e7d32' }}>
                                    ${Number(transaction.amount_paid || 0).toFixed(2)}
                                  </TableCell>
                                  <TableCell className={classes.tablCell} sx={{ color: balance > 0 ? '#e65100' : '#757575', fontWeight: balance > 0 ? 600 : 400 }}>
                                    ${balance.toFixed(2)}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    {transaction?.created_at ? dayjs(transaction.created_at).format("MMM D, YY") : ""}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    <Grid container spacing={0.5} justifyContent="flex-end">
                                      <Grid item>
                                        <Button variant="contained" className={classes.viewButtonList}
                                          onClick={() => handleOpenViewInvoice(String(transaction.id))}>
                                          <DescriptionIcon className={classes.viewListIcon} />
                                        </Button>
                                      </Grid>
                                      <Grid item>
                                        <Button variant="contained" className={classes.viewButtonList}
                                          component={Link} to={`/work-order/history/${transaction.work_order_id}`}>
                                          <VisibilitySharpIcon className={classes.viewListIcon} />
                                        </Button>
                                      </Grid>
                                      <Grid item>
                                        <Button variant="contained" className={classes.editButtonList}
                                          component={Link} to={transaction.work_order_id ? `/quote-history/${transaction.work_order_id}` : `/invoice/edit/${transaction.id}`}>
                                          <EditSharpIcon className={classes.editListIcon} />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {/* {selectedRows.length > 0 && (
                        <Grid>
        <Button disabled={pdfLoading}  variant="contained"
          className={classes.addButton} onClick={handleEmailDialogOpen}>
           {pdfLoading ? <CircularProgress size={24} /> : "Send Email"}
          </Button>
          </Grid>
        )} */}
  <div id="invoice-content" style={{ display: 'none' }}>
    <ViewWorkOrder quoteId={invoiceId} type="email" />
  </div>


 


<Dialog open={showEmailDialog} onClose={handleEmailDialogClose} maxWidth="sm" fullWidth>
          <DialogTitle>Send Email
          <IconButton
      aria-label="close"
      onClick={handleEmailDialogClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
          </DialogTitle>
          <DialogContent>
               <Grid container spacing={1} p={"14px"}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                         To
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              size="small"
              className={classes.textField}
              InputProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              value={invoiceEmailData.to}
              onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
            />
              </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                         Select Template
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
<TextField
   size="small"
   rows={4}
   className={classes.textField}
   InputProps={{
     sx: {
       fontSize: 14,
     },
   }}
   InputLabelProps={{
     sx: {
       fontSize: 14,
     },
   }}
  select
  value={invoiceEmailData.template} // Use state value
 
  onChange={(event) => {
    const selectedTemplateId = event.target.value;
    setInvoiceEmailData({
      ...invoiceEmailData,
      template: selectedTemplateId, // Update selected template
      subject: invoiceEmailData.subject, // Reset subject and message when template changes
      message: invoiceEmailData.message,
    });
  }}

    >
  <MenuItem value="">
    Select option
  </MenuItem>
  {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
      {template.template_name} {/* Display the name of the template */}
    </MenuItem>
  ))}
</TextField>
</Grid>
                                  </Grid>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                        Subject
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
             size="small"
             className={classes.textField}
             InputProps={{
               sx: {
                 fontSize: 14,
               },
             }}
             InputLabelProps={{
               sx: {
                 fontSize: 14,
               },
             }}
              value={invoiceEmailData.subject}
              onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
            />
            </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    {/* Message Label */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Message</Typography>
    </Grid>

    {/* ReactQuill Editor */}
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <ReactQuill
        value={invoiceEmailData.message} // Bind the message value to ReactQuill
        onChange={(value) => setInvoiceEmailData({ ...invoiceEmailData, message: value })} // Update state when content changes
        style={{
          height: "210px", // Set the height of the editor
        }}
      />
    </Grid>
  </Grid>
</Grid>

{/* Attachments Section */}
<Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 5 }}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1" gutterBottom>
        Attachments: {selectedRows.length} invoices selected
      </Typography>
    </Grid>
  </Grid>
</Grid>


            
            </Grid>
          </DialogContent>
          <DialogActions>



          <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                    
            <Button   disabled={loading}   startIcon={<SendIcon />} 
          className={classes.addButton} onClick={handleSendEmail} variant="contained">
            {loading ? <CircularProgress size={24} /> : "Send"}
            </Button>
            </Grid>
            </Grid>
            </Card>
            </Grid>
          </DialogActions>
        </Dialog>



                      {openViewInvoice && (
  <Dialog open={openViewInvoice} onClose={handleCloseViewInvoice} maxWidth="md" fullWidth>
    <DialogTitle>
      <Typography variant="h5" component="div">Invoice Details</Typography>
    </DialogTitle>
    <DialogContent sx={{ p: 0 }}>
      <ViewWorkOrder quoteId={invoiceId} type="view" />
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseViewInvoice}>Close</Button>
    </DialogActions>
  </Dialog>
)}

                 {/* {openViewInvoice && (
                        <ViewInvoice
                          openModel={openViewInvoice}
                          handleCloseDialog={handleCloseViewInvoice}
                          invoiceId={invoiceId}
                        />
                      )} */}


                     
                    </Grid>
                  </Card>
                </Grid>
             

                    )}

          
       



{showContractInvoice && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
    <Card className={classes.card}>
      {/* Header */}
      <Grid container justifyContent="space-between" spacing={2} sx={{ borderBottom: 2, padding: 2 }} className={classes.titleGrid}>
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent="center">
          <Typography className={classes.cardTitle}>Contract Invoices</Typography>
        </Grid>
        <Grid item lg={8} md={8} sm={8} xs={8} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1.5 }}>
          <Button
            variant="contained"
            className={classes.addButton}
            onClick={() => navigate(`/contract-invoice/create/client/${customerId}`)}
          >
            Create Contract Invoice
          </Button>
        </Grid>
      </Grid>

      {/* Table */}
      {contractInvoiceIsLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: "#f8fafc" }}>
                {["#", "Invoice No.", "Issue Date", "Due Date", "PO No.", "Total", "Paid", "Balance", "Status", "Actions"].map((h) => (
                  <TableCell key={h} sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", py: 1.5, px: 2, borderBottom: "1px solid #e2e8f0" }}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(() => {
                const list: IContractInvoice[] = Array.isArray(contractInvoiceData?.data) ? contractInvoiceData!.data as IContractInvoice[] : [];
                const STATUS_MAP: Record<number, { label: string; color: string; bg: string }> = {
                  1: { label: "Draft", color: "#64748b", bg: "#f1f5f9" },
                  2: { label: "Finalized", color: "#d97706", bg: "#fef3c7" },
                  3: { label: "Paid", color: "#16a34a", bg: "#dcfce7" },
                };
                if (list.length === 0) {
                  return (
                    <TableRow>
                      <TableCell colSpan={10} sx={{ textAlign: "center", py: 5, color: "#94a3b8", fontSize: 13 }}>
                        No contract invoices yet.{" "}
                        <Button size="small" onClick={() => navigate(`/contract-invoice/create/client/${customerId}`)} sx={{ textTransform: "none", color: "#2f3891" }}>
                          Create one
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                }
                return list.map((inv, idx) => {
                  const balance = Math.max(0, inv.grand_total - inv.amount_paid);
                  const isPaid = balance === 0 && inv.amount_paid > 0;
                  const st = isPaid ? STATUS_MAP[3] : (STATUS_MAP[inv.status] ?? STATUS_MAP[1]);
                  return (
                    <TableRow key={inv.id} hover sx={{ "&:hover": { bgcolor: "#fafcff" }, "& td": { borderBottom: "1px solid #f1f5f9", py: 1.2, px: 2, fontSize: 13 } }}>
                      <TableCell sx={{ color: "#94a3b8", width: 40 }}>{idx + 1}</TableCell>
                      <TableCell>
                        <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#2563eb", cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
                          onClick={() => navigate(`/contract-invoice/edit/${inv.id}`)}>
                          {inv.contract_invoice_no}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ color: "#475569" }}>{inv.issue_date ? dayjs(inv.issue_date).format("MMM D, YYYY") : "—"}</TableCell>
                      <TableCell sx={{ color: "#475569" }}>{inv.due_date ? dayjs(inv.due_date).format("MMM D, YYYY") : "—"}</TableCell>
                      <TableCell sx={{ color: "#64748b" }}>{inv.po_number || "—"}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>${parseFloat(String(inv.grand_total || 0)).toFixed(2)}</TableCell>
                      <TableCell sx={{ color: inv.amount_paid > 0 ? "#16a34a" : "#94a3b8", fontWeight: inv.amount_paid > 0 ? 600 : 400 }}>
                        ${parseFloat(String(inv.amount_paid || 0)).toFixed(2)}
                      </TableCell>
                      <TableCell sx={{ color: isPaid ? "#16a34a" : balance > 0 ? "#dc2626" : "#94a3b8", fontWeight: 600 }}>
                        ${balance.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        <Chip label={st.label} size="small" sx={{ height: 22, fontSize: 11, fontWeight: 700, color: st.color, bgcolor: st.bg, border: `1px solid ${st.color}33` }} />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 0.5 }}>
                          <Tooltip title="Edit" arrow>
                            <IconButton size="small" onClick={() => navigate(`/contract-invoice/edit/${inv.id}`)}
                              sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: "#eef2ff", color: "#2f3891", "&:hover": { bgcolor: "#e0e7ff" } }}>
                              <EditSharpIcon sx={{ fontSize: 14 }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                });
              })()}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Card>
  </Grid>
)}

{showEmailForm && (


                  <><Grid item lg={12} md={12} sm={12} xs={12}>
                    <form onSubmit={emailFormik.handleSubmit}>
                      <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Card className={classes.card}>
                            <Grid
                              container
                              justifyContent={"space-between"}
                              spacing={5}
                              sx={{ borderBottom: 2, padding: 2 }}
                              className={classes.titleGrid}
                            >
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                pt={2}
                                alignContent={"center"}
                              >
                                <Typography className={classes.cardTitle}>
                                  Compose Email
                                </Typography>
                              </Grid>
                            </Grid>

                            <Grid container spacing={3} p={"24px"}>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      To
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <TextField
                                      placeholder="Enter Email"
                                      size="small"
                                      {...emailFormik.getFieldProps("to")}
                                      className={classes.textField}
                                      InputProps={{
                                        sx: {
                                          fontSize: 14,
                                        },
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          fontSize: 14,
                                        },
                                      }}
                                      error={emailFormik.touched.to &&
                                        Boolean(emailFormik.errors.to)}
                                      helperText={emailFormik.touched.to &&
                                        emailFormik.errors.to}
                                       />
                                  </Grid>
                                </Grid>
                              </Grid>


                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      Subject
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <TextField
                                      placeholder="Enter Subject"
                                      size="small"
                                      {...emailFormik.getFieldProps("subject")}
                                      className={classes.textField}
                                      InputProps={{
                                        sx: {
                                          fontSize: 14,
                                        },
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          fontSize: 14,
                                        },
                                      }} />
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      Message
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div
                                      style={{
                                        height: "210px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px", // Optional: Add some rounding to the corners
                                        overflow: "hidden", // Prevent content overflow
                                      }}
                                    >
                                      <ReactQuill
                                        value={emailFormik.values.message}
                                        onChange={(value) => emailFormik.setFieldValue("message", value)}
                                        style={{
                                          height: "210px",
                                        }} />

                                    </div>


                                  </Grid>
                                </Grid>
                              </Grid>


                              <Grid item lg={10} md={12} sm={12} xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">Select Template</Typography>
                                  </Grid>
                                  <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <TextField
                                      select
                                      size="small"
                                      className={classes.textField}
                                      SelectProps={{
                                        native: false,
                                      }}
                                      defaultValue=""
                                      value={emailFormik.values.template}
                                      InputLabelProps={{ shrink: true }}
                                      onChange={(event) => {
                                        const selectedTemplateId = event.target.value;

                                        const selectedTemplate = emailTemplateList.find(template => template.id === Number(selectedTemplateId));

                                        if (selectedTemplate) {
                                          // Set the form fields for subject and message based on the selected template
                                          emailFormik.setFieldValue("subject", selectedTemplate.subject);
                                          emailFormik.setFieldValue("message", convertPlainTextToHTML(selectedTemplate.message));
                                        } else {
                                          // Reset the subject and message if "Select an option" is chosen
                                          emailFormik.setFieldValue("subject", "");
                                          emailFormik.setFieldValue("message", "");
                                        }
                                        // Set the selected template value
                                        emailFormik.setFieldValue("template", selectedTemplateId);
                                      } }
                                    >
                                      <MenuItem value="Select option">
                                        Select option
                                      </MenuItem>

                                      {emailTemplateList.filter(item => item.is_show === 1).map((template) => (
                                        <MenuItem key={template.id} value={template.id}>
                                          {template.template_name} {/* Display the name of the template */}
                                        </MenuItem>
                                      ))}

                                    </TextField>
                                  </Grid>
                                </Grid>
                              </Grid>



                            </Grid>
                          </Card>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                          <Card className={classes.card}>
                            <Grid container spacing={3} p={"24px"}>
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{ display: "flex", justifyContent: "flex-end" }}
                              >

                                <Button
                                  variant="contained"
                                  startIcon={isEmailSending ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
                                  className={classes.addButton}
                                  onClick={() => emailFormik.handleSubmit()}
                                  disabled={!emailFormValid || isEmailSending}
                                >
                                  {isEmailSending ? "Sending..." : "Send"}
                                </Button>
                              </Grid>
                            </Grid>
                          </Card>
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>
                  
                  
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Email History
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                {/* <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CiSearch
                                          className={classes.searchWidgetIcon} />
                                      </InputAdornment>
                                    ),
                                    classes: {
                                      root: classes.formControlList,
                                    },
                                  }}
                                  fullWidth
                                  value={searchQueryProject}
                                  onChange={(e) => setSearchQueryProject(e.target.value)}
                                  placeholder="Name .."
                                  sx={{ width: "100%" }}
                                  size="small" /> */}
                              </Grid>

                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid>
                          <TableContainer>
                            <Table className={classes.table}>
                              <TableHead className={classes.tableHeaderRow}>
                                <TableRow>
                                <TableCell className={classes.tablheader}>
                                    <strong> Date</strong>
                                  </TableCell>

                                  
                                  <TableCell className={classes.tablheader}>
                                    <strong>Recepient</strong>
                                  </TableCell>
                                 
                                  <TableCell className={classes.tablheader}>
                                    <strong>Subject</strong>
                                  </TableCell>

                               
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {Array.isArray(emailLogs) && emailLogs.length > 0 ? (
            emailLogs
            // .filter(log => log.project_id === null)
            .map((log) => (
              <TableRow key={log.id} className={classes.tableRowHover}>
                <TableCell className={classes.tablCell}>
                  {log?.created_at
                    ? dayjs(log.created_at).format("MMM D, YYYY [at] h:mm A")
                    : ""}
                </TableCell>

                
                <TableCell className={classes.tablCell}>
                  {log.to || ""}
                </TableCell>

                <TableCell className={classes.tablCell}>
                  {log.subject || "No Subject"}
                </TableCell>

               

           

              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={2} className={classes.tablCell}>
                No email logs found.
              </TableCell>
            </TableRow>
          )}
                              </TableBody>
                            </Table>
                          </TableContainer>

                        
                        </Grid>
                      </Card>
                    </Grid>



</>



        )}

{showTextForm && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
    <form onSubmit={textFormik.handleSubmit}>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid item lg={12} md={12} sm={12} xs={12} pt={2} alignContent={"center"}>
                <Typography className={classes.cardTitle}>
                  New SMS Message
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3} p={"24px"}>
              {/* Phone Number */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container alignItems="center">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1">To (Phone Number)</Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <TextField
                      size="small"
                      className={classes.textField}
                      value={textFormik.values.phone_no}
                      onChange={(e) => textFormik.setFieldValue("phone_no", e.target.value)}
                      placeholder="e.g. +14161234567"
                      InputProps={{ sx: { fontSize: 14 } }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Template Selector */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container alignItems="center">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1">Template</Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <TextField
                      select
                      size="small"
                      className={classes.textField}
                      defaultValue=""
                      InputLabelProps={{ shrink: true }}
                      onChange={(event) => {
                        const selectedId = event.target.value;
                        const tpl = smsTemplateList.find((t) => t.id === Number(selectedId));
                        if (tpl) {
                          textFormik.setFieldValue("message", tpl.message);
                        }
                      }}
                    >
                      <MenuItem value="">Select template (optional)</MenuItem>
                      {smsTemplateList.map((tpl) => (
                        <MenuItem key={tpl.id} value={tpl.id}>
                          {tpl.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container alignItems="center">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1">Message</Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextField
                      multiline
                      rows={5}
                      size="small"
                      className={classes.textField}
                      value={textFormik.values.message}
                      onChange={(e) => textFormik.setFieldValue("message", e.target.value)}
                      placeholder="Type your SMS message here..."
                      InputProps={{ sx: { fontSize: 14 } }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
          <Card className={classes.card}>
            <Grid container spacing={3} p={"24px"}>
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  startIcon={isTextSending ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
                  className={classes.addButton}
                  onClick={() => textFormik.handleSubmit()}
                  disabled={!textFormValid || isTextSending}
                >
                  {isTextSending ? "Sending..." : "Send"}
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </form>

    {/* SMS Send History */}
    <Grid container pt={3}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.card}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid item lg={12} md={12} sm={12} xs={12} pt={2} alignContent={"center"}>
              <Typography className={classes.cardTitle}>SMS History</Typography>
            </Grid>
          </Grid>
          <Grid container p={"16px"}>
            {(activityHistoryData?.data?.smsLogs || []).length === 0 ? (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Typography align="center" sx={{ py: 3, color: "text.secondary" }}>
                  No SMS messages sent yet
                </Typography>
              </Grid>
            ) : (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TableContainer>
                  <Table className={classes.table} size="small">
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow>
                        <TableCell className={classes.tablheader}>#</TableCell>
                        <TableCell className={classes.tablheader}>To</TableCell>
                        <TableCell className={classes.tablheader}>Message</TableCell>
                        <TableCell className={classes.tablheader}>Sent At</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(activityHistoryData?.data?.smsLogs || [])
                        .slice()
                        .sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
                        .map((log: any, idx: number) => (
                          <TableRow key={log.id ?? idx} className={classes.tableRowHover}>
                            <TableCell className={classes.tablCell}>{idx + 1}</TableCell>
                            <TableCell className={classes.tablCell}>{log.phone_no || "—"}</TableCell>
                            <TableCell className={classes.tablCell}>{log.message || "—"}</TableCell>
                            <TableCell className={classes.tablCell}>
                              {log.created_at ? dayjs(log.created_at).format("MMM D, YYYY h:mm A") : "—"}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
        </Card>
      </Grid>
    </Grid>
  </Grid>
)}


            {showProfileForm && 
            <><Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                <Card className={classes.stepperCard}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, padding: 2 }}
                            className={classes.titleGrid}
                          >
                           
                            <Grid
                              item
                               lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                              alignContent={"center"}
                            >
                              <Typography className={classes.cardTitle}>
                                Profile Details
                              </Typography>
                            </Grid>

 <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                             

                          <Grid item>
                              <Button
    variant="contained"
    className={classes.editButtonList}
    onClick={() => handleOpenDialog(customer)}
  >
    <EditSharpIcon className={classes.editListIcon} />
  </Button>
                          </Grid>


       <Grid item>
 <Button
                              variant="contained"
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(customer)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
</Grid>



                        </Grid>
                      </Grid>

                            
                          </Grid>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, px: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={4}
                              md={4}
                              sm={4}
                              xs={4}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>
                                  Name
                                </span>{" "}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={8}
                              md={8}
                              sm={8}
                              xs={8}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                             {customer?.customerFirstName || "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* Company Name */}
                        {customer?.customerCompanyName && (
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, px: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"} direction={"column"}>
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>Company / Org</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={8} md={8} sm={8} xs={8} pt={2} alignContent={"center"} direction={"column"}>
                              <Typography variant="subtitle1">{customer.customerCompanyName}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        )}

                        {/* Company Phone */}
                        {customer?.customerCompanyPhoneNumebr && (
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, px: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"} direction={"column"}>
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>Company Phone</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={8} md={8} sm={8} xs={8} pt={2} alignContent={"center"} direction={"column"}>
                              <Typography variant="subtitle1">{customer.customerCompanyPhoneNumebr}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        )}

                        {/* Company Email */}
                        {customer?.customerCompanyEmail && (
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, px: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"} direction={"column"}>
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>Company Email</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={8} md={8} sm={8} xs={8} pt={2} alignContent={"center"} direction={"column"}>
                              <Typography variant="subtitle1">{customer.customerCompanyEmail}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        )}

                        {/* Contact Name (secondary) */}
                        {customer?.customerLastName && (
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, px: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"} direction={"column"}>
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>Contact Name</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={8} md={8} sm={8} xs={8} pt={2} alignContent={"center"} direction={"column"}>
                              <Typography variant="subtitle1">{customer.customerLastName}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        )}

                        {/* Phone No. */}
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, px: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={4}
                              md={4}
                              sm={4}
                              xs={4}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>
                                  Phone No.
                                </span>{" "}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={8}
                              md={8}
                              sm={8}
                              xs={8}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                                   {customer?.customerMobileNum || "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, px: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={4}
                              md={4}
                              sm={4}
                              xs={4}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>
                                  Email
                                </span>{" "}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={8}
                              md={8}
                              sm={8}
                              xs={8}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                                   {customer?.customerEmail || "-"}
                          
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, px: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={4}
                              md={4}
                              sm={4}
                              xs={4}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>
                                 Prefer Time to call
                                </span>{" "}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={8}
                              md={8}
                              sm={8}
                              xs={8}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                                 {customer?.customerPreferTimeToCall || "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>



                        
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ px: 2, pb: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={4}
                              md={4}
                              sm={4}
                              xs={4}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                              <Typography variant="subtitle1">
                                <span className={classes.customerDetails}>
                                    Notes
                                </span>{" "}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={8}
                              md={8}
                              sm={8}
                              xs={8}
                              pt={2}
                              alignContent={"center"}
                              direction={"column"}
                            >
                               <Typography variant="subtitle1">
  {customer?.customerDescription || "-"}
</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              
              
             

                
                
          

        

        </>

      }


      {showHistory && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid item lg={12} md={12} sm={12} xs={12} pt={2} alignContent={"center"}>
                <Typography className={classes.cardTitle}>
                  Activity History
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} p={"16px"}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box
                  sx={{
                    maxHeight: "600px",
                    overflow: "auto",
                    padding: "4px",
                  }}
                >
                  {timeLineSteps.length === 0 ? (
                    <Typography align="center" sx={{ py: 4, color: "text.secondary" }}>
                      No activity history found
                    </Typography>
                  ) : (
                    <Stepper orientation="vertical" activeStep={timeLineSteps.length}>
                      {timeLineSteps.map((step, index) => (
                        <Step key={step.key} completed>
                          <StepLabel>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                              <Typography className={classes.h5}>
                                {step.label}
                                <Typography
                                  variant="subtitle1"
                                  className={classes.showMoreLink}
                                  onClick={() => toggleStepDetails(index)}
                                >
                                  {expandedSteps.includes(index) ? "Show less" : "Show more"}
                                </Typography>
                              </Typography>
                              <Typography variant="caption" color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                                {moment(`${step.date} ${step.time}`).format("MMM DD, YYYY, hh:mm a")}
                              </Typography>
                            </Box>
                          </StepLabel>
                          {expandedSteps.includes(index) && (
                            <Box sx={{ ml: 4, mt: 1 }}>
                              {step.rawHtml ? (
                                <div dangerouslySetInnerHTML={{ __html: step.rawHtml }} />
                              ) : (
                                <Typography>{step.description}</Typography>
                              )}
                            </Box>
                          )}
                        </Step>
                      ))}
                    </Stepper>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      )}


     {showNoteForm && (
         <Grid item lg={12} md={12} sm={12} xs={12}>
         <form onSubmit={noteFormik.handleSubmit}>
           <Grid container>
             <Grid item lg={12} md={12} sm={12} xs={12}>
               <Card className={classes.card}>
                 <Grid
                   container
                   justifyContent={"space-between"}
                   spacing={5}
                   sx={{ borderBottom: 2, padding: 2 }}
                   className={classes.titleGrid}
                 >
                   <Grid
                     item
                     lg={12}
                     md={12}
                     sm={12}
                     xs={12}
                     pt={2}
                     alignContent={"center"}
                   >
                     <Typography className={classes.cardTitle}>
                      New Message
                     </Typography>
                   </Grid>
                 </Grid>

                 <Grid container spacing={3} p={"24px"}>

                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">
                           Subject
                         </Typography>
                       </Grid>
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <TextField
                           placeholder="Enter Subject"
                           size="small"
                           {...noteFormik.getFieldProps("subject")}
                           className={classes.textField}
                           InputProps={{
                             sx: {
                               fontSize: 14,
                             },
                           }}
                           InputLabelProps={{
                             sx: {
                               fontSize: 14,
                             },
                           }}
                          
                         />
                       </Grid>
                     </Grid>
                   </Grid>

                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">
                           Note Message
                         </Typography>
                       </Grid>
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                       <div
       style={{
       height: "210px",
      border:  "1px solid #ccc", 
      borderRadius: "4px", // Optional: Add some rounding to the corners
       overflow: "hidden", // Prevent content overflow
     }}
   >
               <ReactQuill
                 value={noteFormik.values.message}
                 onChange={(value) => noteFormik.setFieldValue("message", value)}
                 style={{
                   height: "210px",
                 }}
               />
               
   </div>

  
                       </Grid>
                     </Grid>
                   </Grid>

                   <Grid item lg={10} md={12} sm={12} xs={12}>
          <Grid container alignItems="center">
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Typography variant="subtitle1">Send as Email</Typography>
              <Switch
                checked={isSendAsEmail}
                onChange={handleToggleChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </Grid>
          </Grid>
        </Grid>
          {isSendAsEmail && (
                   <Grid item lg={10} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">Select Template</Typography>
                       </Grid>
                       <Grid item lg={6} md={6} sm={12} xs={12}>
                         <TextField
                           select
                           size="small"
                           className={classes.textField}
                           SelectProps={{
                             native: false,
                           }}
                           defaultValue=""
                           InputLabelProps={{ shrink: true }}
                           onChange={(event) => {
                             const selectedTemplateId = event.target.value;
                           
                             const selectedTemplate = noteTemplateList.find(template => template.id === Number(selectedTemplateId));
                         
                             if (selectedTemplate) {
                               // Set the form fields for subject and message based on the selected template
                               noteFormik.setFieldValue("subject", selectedTemplate.subject);
                               noteFormik.setFieldValue("message", convertPlainTextToHTML(selectedTemplate.note_message));
                           }
                          
                            //  noteFormik.setFieldValue("template", selectedTemplateId);
                           }}
                         >
                           <MenuItem value="Select option" >
                             Select option
                           </MenuItem>
                         
       {noteTemplateList.map((template) => (
         <MenuItem key={template.id} value={template.id}>
           {template.note_title} {/* Display the name of the template */}
         </MenuItem>
       ))}
                         
                         </TextField>
                       </Grid>
                     </Grid>
                   </Grid>

)}

                 </Grid>
               </Card>
             </Grid>

             <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
               <Card className={classes.card}>
                 <Grid container spacing={3} p={"24px"}>
                   <Grid
                     item
                     lg={12}
                     md={12}
                     sm={12}
                     xs={12}
                     sx={{ display: "flex", justifyContent: "flex-end" }}
                   >
                   
                     <Button
                       variant="contained"
                       startIcon={<SendIcon />}
                       className={classes.addButton}
                       onClick={() => noteFormik.handleSubmit()}
                       disabled={!noteFormValid || isNoteSaving ||isNoteEmailSaving}
                     >
                     { isSendAsEmail ?'Send' : 'Save'}
                     </Button>
                   </Grid>
                 </Grid>
               </Card>
             </Grid>
           </Grid>
         </form>
       </Grid>
        )}



          </Grid>
        </Grid>





      

        <Grid item lg={4} md={4} sm={12} xs={12} >
          <Grid container spacing={2} >

 {/* Stat Cards */}
 <Grid item xs={12}>
   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 2, px: 1 }}>
     {/* Invoices Count */}
     <Card elevation={0} sx={{
       borderRadius: 2, border: '1px solid #e8edf2',
       background: 'linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)',
     }}>
       <CardContent sx={{ py: '12px !important', px: 2 }}>
         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           <Box>
             <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8, fontSize: '0.68rem' }}>
               Total Invoices
             </Typography>
             <Typography variant="h5" sx={{ fontWeight: 700, color: '#2e7d32', lineHeight: 1.2 }}>
               {totalSales}
             </Typography>
           </Box>
           <Box sx={{ width: 42, height: 42, borderRadius: '50%', bgcolor: '#c8e6c9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
             <ReceiptIcon sx={{ color: '#2e7d32', fontSize: 22 }} />
           </Box>
         </Box>
       </CardContent>
     </Card>

     {/* Total Revenue */}
     <Card elevation={0} sx={{
       borderRadius: 2, border: '1px solid #e8edf2',
       background: 'linear-gradient(135deg, #e3f2fd 0%, #e8f4ff 100%)',
     }}>
       <CardContent sx={{ py: '12px !important', px: 2 }}>
         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           <Box>
             <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8, fontSize: '0.68rem' }}>
               Total Revenue
             </Typography>
             <Typography variant="h5" sx={{ fontWeight: 700, color: '#0277bd', lineHeight: 1.2 }}>
               ${totalAmount.toFixed(2)}
             </Typography>
           </Box>
           <Box sx={{ width: 42, height: 42, borderRadius: '50%', bgcolor: '#bbdefb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
             <AssignmentIcon sx={{ color: '#0277bd', fontSize: 22 }} />
           </Box>
         </Box>
       </CardContent>
     </Card>

     {/* Outstanding Balance */}
     <Card elevation={0} sx={{
       borderRadius: 2, border: '1px solid #e8edf2',
       background: totalDueAmount > 0
         ? 'linear-gradient(135deg, #fff3e0 0%, #fff8e1 100%)'
         : 'linear-gradient(135deg, #f3f3f3 0%, #fafafa 100%)',
     }}>
       <CardContent sx={{ py: '12px !important', px: 2 }}>
         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           <Box>
             <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8, fontSize: '0.68rem' }}>
               Outstanding Balance
             </Typography>
             <Typography variant="h5" sx={{ fontWeight: 700, color: totalDueAmount > 0 ? '#e65100' : '#757575', lineHeight: 1.2 }}>
               ${totalDueAmount.toFixed(2)}
             </Typography>
           </Box>
           <Box sx={{ width: 42, height: 42, borderRadius: '50%', bgcolor: totalDueAmount > 0 ? '#ffe0b2' : '#eeeeee', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
             <InfoIcon sx={{ color: totalDueAmount > 0 ? '#e65100' : '#9e9e9e', fontSize: 22 }} />
           </Box>
         </Box>
       </CardContent>
     </Card>

     {/* Last activity */}
     {lastSaleDate && (
       <Card elevation={0} sx={{ borderRadius: 2, border: '1px solid #e8edf2', bgcolor: '#fafafa' }}>
         <CardContent sx={{ py: '10px !important', px: 2 }}>
           <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8, fontSize: '0.68rem' }}>
             Last Activity
           </Typography>
           <Typography variant="body2" sx={{ fontWeight: 600, color: '#444', mt: 0.3 }}>
             {moment(lastSaleDate).format('MMM D, YYYY')}
           </Typography>
         </CardContent>
       </Card>
     )}
   </Box>
 </Grid>







   <Grid container spacing={1} justifyContent="center"  sx={{ marginTop: 1,marginLeft: 1 }}>
   {[[`Invoice`, totalAmount] as [string, number]].map(([categoryName, totalAmount]) => {

        const pieData = calculatePieData(categoryName); 

        return (
          <Grid item xs={12} sm={12} md={12} key={categoryName}>
            <Card elevation={3} sx={{  display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
                <Grid container direction="column" alignItems="center">
                  {/* Category Name */}
                 
                  {/* <Typography variant="body2" mt={2} align="center" sx={{ fontWeight: 'bold', fontSize: '15px' }}>
                  {categoryName}</Typography> */}


                 <Grid container direction="row" alignItems="center" spacing={2} sx={{ marginTop: '10px' }}>
          {/* Left: Pie Chart */}
          <Grid item md={8} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ width: '150px', height: '150px' }}>
            <Pie
  data={calculatePieData(categoryName)}
  options={{
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const { dataIndex, dataset } = tooltipItem;
            const totalValue = dataset.data.reduce((a, b) => a + b, 0); // Sum of all values in the dataset
            const value = dataset.data[dataIndex] as number;

            // Calculate the percentage for the category slice relative to totalExpense
            let percentage = "0.00";
            if (dataIndex === 0) {
              percentage = ((value / overallAmount) * 100).toFixed(2); // Percentage based on overallExpense
            }

            if (dataIndex === 0) {
              // Show category-specific percentage in tooltip
              return `${percentage}%`; // Display category percentage
            }
            // Show value for overall expense in tooltip
            return `${value.toFixed(2)}`;
          },
        },
      },
      legend: {
        display: true,
        labels: {
          color: '#000',
        },
      },
    },
  }}
/>

            </Box>
          </Grid>

          {/* Right: Percentage Display */}
          <Grid item md={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box sx={{ textAlign: 'center' }}>
            {/* <Typography variant="body2" >
                Total  {totalSales}
              </Typography> */}
              <Typography variant="h3" sx={{ fontSize: '1.2rem'}}>
               {/* {((categoryData[categoryName] / amount ) * 100).toFixed(2)}% */}
               {overallAmount > 0
             ? ((totalAmount / overallAmount) * 100).toFixed(2)
             : "0.00"}%
        
           
              </Typography>
             
            </Box>
          </Grid>
        </Grid>


      

                </Grid>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>


            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2, width:'minContent'  }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Activity History
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                        className={classes.titleGrid}
                      >
                        <Box
                          sx={{
                            height: "600px",
                            overflow: "auto",
                             padding: "2px",
                            "&::-webkit-": {
                              width: "4px",
                            },
                            "&::-webkit--track": {
                              background: "#eeeeee",
                            },
                            "&::-webkit--thumb": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit--thumb:hover": {
                              background: "#eeeeee",
                            },
                          }}
                        >
                           <div>
    {timeLineSteps.length === 0 ? (
      <p style={{ textAlign: "center", padding: "20px" }}>No activity history found</p>
    ) : (
                          <Stepper
                            orientation="vertical"
                            activeStep={timeLineSteps.length}
                          >
                            {timeLineSteps.map((step, index) => (
                              <Step key={step.key} completed>
                                <StepLabel>
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                 
                                  >
                                    <Typography className={classes.h5}>
                                      {step.label}
                                      <Typography
                                        variant="subtitle1"
                                        className={classes.showMoreLink}
                                        onClick={() => toggleStepDetails(index)}
                                      >
                                        {expandedSteps.includes(index)
                                          ? "Show less"
                                          : "Show more"}
                                      </Typography>
                                      <Typography
                                        variant="caption"
                                        color="textSecondary"
                                      >
                                   
                                      </Typography>
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      color="textSecondary"
                                      style={{whiteSpace:'nowrap'}}
                                    >
                                      {/* {step.date}{step.time} */}
                                      {moment(`${step.date} ${step.time}`).format("MMM DD, YYYY, hh:mm a")}
                                    </Typography>
                                  </Box>
                                </StepLabel>

                                {expandedSteps.includes(index) && (
                                  <Box sx={{ ml: 4, mt: 1 }}>
                                    {step.rawHtml ? (
                                      <div dangerouslySetInnerHTML={{ __html: step.rawHtml }} />
                                    ) : (
                                      <Typography>{step.description}</Typography>
                                    )}
                                  </Box>
                                )}
                              </Step>
                            ))}


{/* {timeLineSteps
                                      .slice()
                                      // .reverse() 
                                      .map((step, index) => (
                                        <Step key={step.label} completed>
                                          <StepLabel>
                                            <Box
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                            >
                                              <Typography
                                                className={classes.h5}
                                              >
                                                {step.label}
                                              </Typography>
                                              <Button
                                                variant="contained"
                                                className={
                                                  classes.editButtonList
                                                }
                                                onClick={() =>
                                                  toggleStepDetails(index)
                                                }
                                              >
                                                {expandedSteps.includes(
                                                  index
                                                ) ? (
                                                  <ExpandLessSharpIcon
                                                    className={
                                                      classes.editListIcon
                                                    }
                                                  />
                                                ) : (
                                                  <ExpandMoreSharpIcon
                                                    className={
                                                      classes.editListIcon
                                                    }
                                                  />
                                                )}
                                              </Button>
                                            </Box>
                                          </StepLabel>

                                          {expandedSteps.includes(index) && (
                                            <Box sx={{ ml: 4, mt: 1 }}>
                                              <Typography>
                                                {step.description}
                                              </Typography>
                                            </Box>
                                          )}
                                        </Step>
                                      ))} */}

                           
                          </Stepper>
                          )}
  </div>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
              <Card className={classes.stepperCard}></Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>



       {selectCustomer && (
                        <NewPopUpCustomer
                          openModel={openDialog}
                          handleCloseDialog={handleCloseDialog}
                          data={selectCustomer}
                        />
                      )}
                      {openAddTransaction && (
                        <NewCustomerTransactionPopUp
                          openModel={openAddTransaction}
                          handleCloseDialog={handleCloseAddTransaction}
                          data={transactionData}
                          customerId={customerId}
                        />
                      )}
                      {coursingToDelete && (
                        <DeletePopup
                          open={openDeleteCategory}
                          handleCloseDelete={handleCloseDeletePopup}
                          onConfirm={async () => {
                            await handleDelete(coursingToDelete.id.toString());
                          }}
                          title="Delete Customer"
                         content={`Are you sure you want to delete "${
              coursingToDelete.customerFirstName
            }"?`}
                        />
                      )}


      <div
  id="quote-content" 
   style={{
    display: 'none',
  }}
  >

 <ViewWorkOrder quoteId={quoteId} type="email" />


  
  </div>






    </div>









  );
};

export default Index;
